import ContactSearchModal from "../ContactSearchModal";
import QuickMessageModal from "../QuickMessageModal";
import CatalogProductPickerModal from "../CatalogProductPickerModal";
import DocumentSendModal from "../DocumentSendModal";
import PersonIcon from "@material-ui/icons/Person";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import DescriptionIcon from "@material-ui/icons/Description";
import StorefrontIcon from "@material-ui/icons/Storefront";
import React, { useState, useEffect, useContext, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import withWidth from "@material-ui/core/withWidth";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";
import MicRecorder from "mic-recorder-to-mp3";
import clsx from "clsx";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import ImageIcon from "@material-ui/icons/Image";
import MovieIcon from "@material-ui/icons/Movie";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import AudiotrackIcon from "@material-ui/icons/Audiotrack";
import ArchiveIcon from "@material-ui/icons/Archive";
import IconButton from "@material-ui/core/IconButton";
import MoodIcon from "@material-ui/icons/Mood";
import SendIcon from "@material-ui/icons/Send";
import CancelIcon from "@material-ui/icons/Cancel";
import ClearIcon from "@material-ui/icons/Clear";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import MicIcon from "@material-ui/icons/Mic";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import PauseCircleOutlineIcon from "@material-ui/icons/PauseCircleOutline";
import MessageIcon from "@material-ui/icons/Message";
import SettingsPhoneIcon from "@material-ui/icons/SettingsPhone";
import CollectionsIcon from "@material-ui/icons/Collections";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, FormControl, InputLabel, Select, MenuItem, TextField, Box, Typography, Menu, Tooltip, ListItemText, ListItemIcon, SvgIcon, Switch } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { isString, isEmpty, isObject, has } from "lodash";
import { toast } from "react-toastify";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import axios from "axios";

import RecordingTimer from "./RecordingTimer";
import { enableRecorderPause, pauseRecorder, resumeRecorder } from "./pausableRecorder";
import ForbiddenWordWarningModal from "../ForbiddenWordWarningModal";
import ConnectionSelectDialog from "../ConnectionSelectDialog";
import QueueSelectDialog from "../QueueSelectDialog";
import ConfirmationModal from "../ConfirmationModal";
import { detectForbiddenTerms, applyReplacements } from "../../utils/forbiddenWords";
import { getQuickMessageMedias } from "../../utils/quickMessageMedias";
import { ReplyMessageContext } from "../../context/ReplyingMessage/ReplyingMessageContext";
import { EditingMessageContext } from "../../context/EditingMessage/EditingMessageContext";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { SettingsContext } from "../../context/Settings/SettingsContext";
import {
  isPerConnectionContact,
  isPerConnectionContactTickets,
} from "../../helpers/contactTicketMode";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import toastError from "../../errors/toastError";
import hasOpenOverlay from "../../helpers/hasOpenOverlay";
import PendingMessagesContext from '../../context/PendingMessages/PendingMessagesContext';
import OptimisticMessagesContext from '../../context/OptimisticMessages/OptimisticMessagesContext';
import { OptimisticMessagesContext as OptimisticContext } from '../../context/OptimisticMessages/OptimisticMessagesContext';

import useQuickMessages from "../../hooks/useQuickMessages";
import { extractVariables } from "../../utils/templateValidator";
import TicketAIAgentModal from "../TicketAIAgentModal";

const Mp3Recorder = new MicRecorder({ bitRate: 128 });
const PENDING_PRIVATE_REPLY_KEY = "pendingPrivateReply";
const MESSAGE_DRAFT_CACHE = new Map();
// Envio com arquivo (mídia, figurinha, áudio): o timeout de 30 s do api.js
// cortava o upload em conexão lenta e o atendente via "timeout of 30000ms" com
// o arquivo ainda subindo. 300 s é o mesmo teto do requestTimeout do Node.
const MEDIA_UPLOAD_TIMEOUT_MS = 300000;

const RobotIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <rect x="6" y="8" width="12" height="10" rx="2" />
    <circle cx="10" cy="13" r="1.2" fill="currentColor" />
    <circle cx="14" cy="13" r="1.2" fill="currentColor" />
    <rect x="10.5" y="4" width="3" height="2" rx="0.5" />
    <rect x="11.25" y="6" width="1.5" height="2" rx="0.5" />
    <rect x="4" y="10.5" width="2" height="5" rx="1" />
    <rect x="18" y="10.5" width="2" height="5" rx="1" />
    <rect x="10" y="16" width="4" height="1.5" rx="0.75" fill="currentColor" />
  </SvgIcon>
);

const useStyles = makeStyles((theme) => ({

    dropZoneOverlay: {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 174, 239, 0.12)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "#00aeef",
        border: "1px dashed #00aeef",
        borderRadius: 10,
        fontSize: "16px",
        fontWeight: 600,
        zIndex: 4,
        pointerEvents: "none",
    },

  mainWrapper: {
    backgroundColor: theme.palette.bordabox, //DARK MODE PLW DESIGN//
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  newMessageBox: {
    backgroundColor: theme.palette.newmessagebox, //DARK MODE PLW DESIGN//
    width: "100%",
    display: "flex",
    padding: "4px",
    alignItems: "center",
    position: "relative",
    transition: "background-color 160ms ease, box-shadow 160ms ease, border-color 160ms ease",
    border: "1px dashed transparent",
    borderRadius: 10,
    // Ao mexer neste padding, ajustar emojiBox.bottom pela MESMA diferença:
    // aquele valor é a altura deste rodapé, chumbada.
  },

  newMessageBoxDragActive: {
    backgroundColor: "rgba(0, 174, 239, 0.12)",
    borderColor: "#00aeef",
    boxShadow: "0 0 0 1px rgba(0, 174, 239, 0.4) inset",
  },

  dropHintOverlay: {
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none",
    borderRadius: 10,
    color: "#00aeef",
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: 0.2,
  },

  messageInputWrapper: {
    padding: 6,
    marginRight: 7,
    backgroundColor: theme.palette.inputdigita, //DARK MODE PLW DESIGN//
    display: "flex",
    borderRadius: 20,
    flex: 1,
  },

  messageInput: {
    paddingLeft: 10,
    flex: 1,
    border: "none",
  },

  sendMessageIcons: {
    color: "grey",
  },

  uploadInput: {
    display: "none",
  },

  viewMediaInputWrapper: {
    display: "flex",
    padding: "10px 13px",
    position: "relative",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: theme.palette.mediainput, //DARK MODE
    borderTop: "1px solid rgba(0, 0, 0, 0.12)",
  },

  mediaInputCaption: {
    padding: "6px 12px",
    backgroundColor: theme.palette.inputdigita, //DARK MODE
    borderRadius: 20,
    fontSize: "14px",
    color: theme.palette.type === "dark" ? "#fff" : "inherit",
  },

  mediaInputFileName: {
    fontSize: "12px",
    color: theme.palette.type === "dark" ? "#ccc" : "#666",
    marginBottom: 4,
  },

  mediaPreviewList: {
    display: "flex",
    gap: 10,
    overflowX: "auto",
    marginBottom: 8,
    paddingBottom: 4,
  },

  mediaPreviewCard: {
    position: "relative",
    width: 96,
    minWidth: 96,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 4,
  },

  mediaPreviewThumb: {
    width: 96,
    height: 96,
    borderRadius: 8,
    objectFit: "cover",
    backgroundColor: "rgba(0,0,0,0.06)",
  },

  mediaPreviewFallback: {
    width: 96,
    height: 96,
    borderRadius: 8,
    backgroundColor: "rgba(0,0,0,0.06)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  mediaPreviewName: {
    width: "100%",
    fontSize: 10,
    color: theme.palette.type === "dark" ? "#ccc" : "#666",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    textAlign: "center",
  },

  removeMediaButton: {
    position: "absolute",
    top: -8,
    right: -8,
    padding: 2,
    backgroundColor: theme.palette.background.paper,
    border: "1px solid rgba(0,0,0,0.12)",
    zIndex: 2,
  },

  addMoreMediaCard: {
    width: 96,
    minWidth: 96,
    height: 96,
    borderRadius: 8,
    border: `1px dashed ${theme.palette.type === "dark" ? "rgba(255,255,255,0.35)" : "rgba(0,0,0,0.25)"}`,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,0.04)" : "rgba(0,0,0,0.03)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },

  addMoreMediaIcon: {
    fontSize: 34,
    color: theme.palette.type === "dark" ? "#d2d2d2" : "#666",
  },

  // O `bottom` não é arbitrário: é a altura do rodapé (newMessageBox), para o
  // seletor de emoji abrir encostado nele. Se o padding do newMessageBox
  // mudar, este valor muda junto — 7->4 de padding tirou 6px da altura, daí
  // os 57 no lugar dos 63 originais.
  emojiBox: {
    position: "absolute",
    bottom: 57,
    width: 40,
    borderTop: "1px solid #e8e8e8",
  },

  circleLoading: {
    color: green[500],
    opacity: "70%",
    position: "absolute",
    top: "20%",
    left: "50%",
    marginLeft: -12,
  },

  audioLoading: {
    color: green[500],
    opacity: "70%",
  },

  recorderWrapper: {
    display: "flex",
    alignItems: "center",
    alignContent: "middle",
  },

  cancelAudioIcon: {
    color: "red",
  },

  sendAudioIcon: {
    color: "green",
  },

  resumeAudioIcon: {
    color: "#e53935",
  },

  replyginMsgWrapper: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 4,
    paddingLeft: 73,
    paddingRight: 7,
  },

  replyginMsgContainer: {
    flex: 1,
    marginRight: 5,
    overflowY: "hidden",
    backgroundColor: "rgba(0, 0, 0, 0.05)",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  replyginMsgBody: {
    padding: 10,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  replyginContactMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  pendingAcceptWrapper: {
    position: "relative",
    width: "100%",
  },

  pendingAcceptOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 10,
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    pointerEvents: "auto",
  },

  acceptButton: {
    backgroundColor: "#25D366",
    color: "#fff",
    padding: "4px 48px",
    borderRadius: "8px",
    fontSize: "16px",
    fontWeight: "bold",
    textTransform: "uppercase",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    "&:hover": {
      backgroundColor: "#20bd5a",
    },
  },

  replyginSelfMsgSideColor: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  stickersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(72px, 1fr))",
    gap: 8,
    marginTop: 12,
    maxHeight: 320,
    overflowY: "auto",
    // Os botões de ação (estrela e lixeira) saem 6px para fora do tile. Sem esta
    // folga as barras de rolagem — vertical à direita, horizontal embaixo — ficam
    // por cima deles, e a estrela da primeira linha é cortada no topo.
    padding: "8px 14px 14px 8px",
    boxSizing: "border-box",
  },

  stickerItemButton: {
    border: "1px solid rgba(0,0,0,0.12)",
    borderRadius: 8,
    minWidth: 72,
    width: 72,
    height: 72,
    padding: 2,
  },

  stickerTileWrapper: {
    position: "relative",
    width: 72,
    height: 72,
  },

  stickerFavoriteButton: {
    position: "absolute",
    top: -6,
    right: -6,
    backgroundColor: theme.palette.background.paper,
    zIndex: 2,
    padding: 2,
  },

  // Canto oposto ao da estrela para não sobrepor no tile de 72x72. Sempre visível
  // (não só no hover) porque o app também é usado em tablet/touch. O span existe
  // porque o Tooltip do MUI não funciona com um filho desabilitado.
  stickerDeleteButton: {
    position: "absolute",
    bottom: -6,
    right: -6,
    backgroundColor: theme.palette.background.paper,
    borderRadius: "50%",
    lineHeight: 0,
    zIndex: 2,
    opacity: 0.85,
    "&:hover": {
      opacity: 1,
    },
  },

  stickerThumb: {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
  },
}));

const FileInput = (props) => {
  const { handleChangeMedias, disableOption } = props;
  const classes = useStyles();
  return (
    <>
      <input
        multiple
        type="file"
        id="upload-button"
        disabled={disableOption()}
        className={classes.uploadInput}
        onChange={handleChangeMedias}
      />
      <label htmlFor="upload-button">
        <Tooltip title={i18n.t("messagesInput.tooltips.attachFile")}>
          <IconButton
            aria-label="upload"
            component="span"
            disabled={disableOption()}
          >
            <AttachFileIcon className={classes.sendMessageIcons} />
          </IconButton>
        </Tooltip>
      </label>
    </>
  );
};

const ActionButtons = (props) => {
  const {
    inputMessage,
    loading,
    sendingText,
    recording,
    recordingPaused,
    ticketStatus,
    handleSendMessage,
    handleCancelAudio,
    handleUploadAudio,
    handleStartRecording,
    handlePauseAudio,
    handleResumeAudio,
  } = props;
  const classes = useStyles();
  if (inputMessage) {
    return (
      <Tooltip title={i18n.t("messagesInput.tooltips.sendMessage")}>
        <IconButton
          aria-label="sendMessage"
          component="span"
          onClick={handleSendMessage}
          disabled={loading || sendingText}
        >
          <SendIcon className={classes.sendMessageIcons} />
        </IconButton>
      </Tooltip>
    );
  } else if (recording) {
    return (
      <div className={classes.recorderWrapper}>
        <IconButton
          aria-label="cancelRecording"
          component="span"
          fontSize="large"
          disabled={loading}
          onClick={handleCancelAudio}
        >
          <HighlightOffIcon className={classes.cancelAudioIcon} />
        </IconButton>
        {loading ? (
          <div>
            <CircularProgress className={classes.audioLoading} />
          </div>
        ) : (
          <RecordingTimer paused={recordingPaused} />
        )}

        {/* Pausar e continuar a MESMA gravação, como no WhatsApp. */}
        {recordingPaused ? (
          <Tooltip title={i18n.t("messagesInput.tooltips.resumeRecording")}>
            <IconButton
              aria-label="resumeRecording"
              component="span"
              onClick={handleResumeAudio}
              disabled={loading}
            >
              <MicIcon className={classes.resumeAudioIcon} />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title={i18n.t("messagesInput.tooltips.pauseRecording")}>
            <IconButton
              aria-label="pauseRecording"
              component="span"
              onClick={handlePauseAudio}
              disabled={loading}
            >
              <PauseCircleOutlineIcon />
            </IconButton>
          </Tooltip>
        )}

        <IconButton
          aria-label="sendRecordedAudio"
          component="span"
          onClick={handleUploadAudio}
          disabled={loading}
        >
          <CheckCircleOutlineIcon className={classes.sendAudioIcon} />
        </IconButton>
      </div>
    );
  } else {
    return (
      <Tooltip title={i18n.t("messagesInput.tooltips.voiceMessage")}>
        <IconButton
          aria-label="showRecorder"
          component="span"
          disabled={loading}
          onClick={handleStartRecording}
        >
          <MicIcon className={classes.sendMessageIcons} />
        </IconButton>
      </Tooltip>
    );
  }
};

const CustomInput = (props) => {
  const {
    loading,
    sendingText,
    inputRef,
    ticketStatus,
    inputMessage,
    setInputMessage,
    handleSendMessage,
    handleInputPaste,
    disableOption,
    handleQuickAnswersClick,
    disableAutoFocus,
    whatsapps,
    selectedWhatsappId,
    onWhatsappChange,
    cloudApiWindowClosed,
    templateOnlyMode,
    groupParticipants = [],
    onMentionSelected,
  } = props;
  const classes = useStyles();
  const [quickMessages, setQuickMessages] = useState([]);
  const [options, setOptions] = useState([]);
  const [popupOpen, setPopupOpen] = useState(false);
  const [connDialogOpen, setConnDialogOpen] = useState(false);
  const didAutoFocusRef = useRef(false);

  const showWhatsappSelector = whatsapps && whatsapps.length > 0 && onWhatsappChange;
  const { user } = useContext(AuthContext);

  const { list: listQuickMessages } = useQuickMessages();

  const isLidLikeValue = (value) => {
    const rawValue = String(value || "").trim();
    if (!rawValue) return false;

    const normalized = rawValue.toLowerCase();
    if (normalized.includes("@lid")) return true;

    const localPart = normalized.split("@")[0].trim();
    return /^\d{14,}(?::\d+)?$/.test(localPart);
  };

  const getParticipantDisplayName = (participant) => {
    const nameCandidates = [
      participant?.displayName,
      participant?.participantName,
      participant?.name,
      participant?.pushName,
    ];

    for (const candidate of nameCandidates) {
      const cleanCandidate = String(candidate || "").trim();
      if (!cleanCandidate) continue;
      if (isLidLikeValue(cleanCandidate)) continue;
      return cleanCandidate;
    }

    const numberDigits = String(participant?.participantNumber || "").replace(/\D/g, "");
    if (numberDigits && !isLidLikeValue(numberDigits)) {
      return numberDigits;
    }

    return i18n.t("messagesInput.mentionFallbackName");
  };

  useEffect(() => {
    let cancelled = false;

    async function fetchData() {
      const companyId = localStorage.getItem("companyId");
      const messages = await listQuickMessages({ companyId });
      const options = messages.map((m) => {
        let truncatedMessage = m.message;
        if (isString(truncatedMessage) && truncatedMessage.length > 35) {
          truncatedMessage = m.message.substring(0, 35) + "...";
        }
        return {
          value: m.message,
          label: `/${m.shortcode} - ${truncatedMessage}`,
          mediaPath: m.mediaPath,
          medias: m.medias,
          documentTemplateId: m.documentTemplateId,
        };
      });
      if (cancelled) return;
      setQuickMessages(options);
    }
    fetchData();

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      isString(inputMessage) &&
      !isEmpty(inputMessage)
    ) {
      const normalize = (value = "") =>
        value
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

      const mentionMatch = inputMessage.match(/(?:^|\s)@([^\s@]*)$/);

      if (mentionMatch && Array.isArray(groupParticipants) && groupParticipants.length > 0) {
        const mentionQuery = normalize(mentionMatch[1] || "");
        const mentionDigits = (mentionMatch[1] || "").replace(/\D/g, "");

        const mentionOptions = groupParticipants
          .filter((participant) => {
            const participantDisplayName = getParticipantDisplayName(participant);
            const name = normalize(participantDisplayName || "");
            const number = String(participant.participantNumber || "").replace(/\D/g, "");

            if (!mentionQuery) return !!name;

            return (
              name.includes(mentionQuery) ||
              (!!mentionDigits && number.includes(mentionDigits))
            );
          })
          .slice(0, 15)
          .map((participant) => {
            const participantDisplayName = getParticipantDisplayName(participant);
            const numberDigits = String(participant.participantNumber || "").replace(/\D/g, "");
            const jidLocal = String(participant.participantJid || "").split("@")[0].split(":")[0];
            const mentionToken = participantDisplayName;
            const mentionWireToken = jidLocal || (numberDigits.length >= 8 ? numberDigits : "");
            const mentionMatchTokens = [participantDisplayName, jidLocal, numberDigits]
              .map((token) => String(token || "").trim())
              .filter(Boolean);

            return {
              type: "mention",
              label: `@${participantDisplayName}`,
              value: participantDisplayName,
              mentionToken,
              mentionWireToken,
              mentionMatchTokens,
              participantJid: participant.participantJid,
              participantNumber: participant.participantNumber,
            };
          });

        setOptions(mentionOptions);
        setPopupOpen(mentionOptions.length > 0);
        return;
      }

      const firstWord = inputMessage.charAt(0);
      const showQuickMessages = firstWord.indexOf("/") > -1;
      setPopupOpen(showQuickMessages);

      if (showQuickMessages) {
        const filteredOptions = quickMessages.filter(
          (m) => m.label.indexOf(inputMessage) > -1
        );
        setOptions(filteredOptions);
      } else {
        setOptions([]);
      }
    } else {
      setPopupOpen(false);
      setOptions([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputMessage, groupParticipants]);

  const onKeyPress = (e) => {
    if (loading || sendingText || e.shiftKey) return;
    if (popupOpen) return;
    else if (e.key === "Enter") {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const onPaste = (e) => {
    if (ticketStatus === "open" || ticketStatus === "closed" || ticketStatus === "pending") {
      handleInputPaste(e);
    }
  };

  const renderPlaceholder = () => {
    if (cloudApiWindowClosed) {
      return i18n.t("messagesInput.cloudApi.windowExpiredPlaceholder");
    }
    if (ticketStatus === "open" || ticketStatus === "pending") {
      return i18n.t("messagesInput.placeholderOpen");
    }
    if (ticketStatus === "closed") {
      return i18n.t("messagesInput.placeholderReopen");
    }
    return i18n.t("messagesInput.placeholderClosed");
  };


  const setInputRef = useCallback((input) => {
    if (!input) return;

    inputRef.current = input;

    if (disableAutoFocus || didAutoFocusRef.current) {
      return;
    }

    const activeElement = document.activeElement;
    const isTypingInAnotherField =
      activeElement &&
      activeElement !== document.body &&
      activeElement !== input &&
      (activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA" ||
        activeElement.isContentEditable);

    if (!isTypingInAnotherField) {
      input.focus();
      didAutoFocusRef.current = true;
    }
  }, [disableAutoFocus, inputRef]);

  useEffect(() => {
    if (disableAutoFocus) {
      didAutoFocusRef.current = false;
    }
  }, [disableAutoFocus]);

  return (
    <div className={classes.messageInputWrapper}>
      {showWhatsappSelector && (
        <>
          <Tooltip title={selectedWhatsappId
            ? i18n.t("messagesInput.connection.selectedTooltip", { name: whatsapps.find(w => w.id === selectedWhatsappId)?.name || i18n.t("messagesInput.connection.selectedFallback") })
            : i18n.t("messagesInput.connection.select")
          }>
            <IconButton
              size="small"
              onClick={() => setConnDialogOpen(true)}
              style={{
                padding: 4,
                marginRight: 2,
                color: selectedWhatsappId ? "#25d366" : "#999",
              }}
            >
              <SettingsPhoneIcon fontSize="small" />
            </IconButton>
          </Tooltip>
          <ConnectionSelectDialog
            open={connDialogOpen}
            onClose={() => setConnDialogOpen(false)}
            whatsapps={whatsapps}
            selectedWhatsappId={selectedWhatsappId}
            allowAutomatic
            onSelect={(w) => onWhatsappChange(w ? w.id : "")}
            title={i18n.t("messagesInput.connection.select")}
          />
        </>
      )}
      {templateOnlyMode ? (
        <Box
          style={{
            width: "100%",
            paddingLeft: 10,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" color="textSecondary">
            {i18n.t("messagesInput.cloudApi.windowExpiredInline")}
          </Typography>
        </Box>
      ) : (
      <Autocomplete
        freeSolo
        open={popupOpen}
        id="grouped-demo"
        value={inputMessage}
        options={options}
        closeIcon={null}
        getOptionLabel={(option) => {
          if (isObject(option)) {
            return option.label;
          } else {
            return option;
          }
        }}
        renderOption={(option) => {
          if (option?.type === "mention") {
            return (
              <div>
                <strong>{option.label}</strong>
                {option.participantNumber ? ` (${option.participantNumber})` : ""}
              </div>
            );
          }
          return option.label || option;
        }}
        onChange={(event, opt) => {
          if (isObject(opt) && opt.type === "mention") {
            if (typeof onMentionSelected === "function") {
              onMentionSelected(opt);
            }
            setInputMessage((prevMessage) => {
              const safeMessage = prevMessage || "";
              return safeMessage.replace(/(^|\s)@([^\s@]*)$/, `$1@${opt.mentionToken} `);
            });
            setPopupOpen(false);
            setTimeout(() => {
              inputRef.current?.focus();
            }, 50);
            return;
          }

          if (isObject(opt) && has(opt, "value")) {
            // replaceInput: o atalho digitado ("/x") deve sumir do input, dando lugar
            // ao texto da resposta rápida. Se o atalho tiver modelo de documento
            // vinculado, handleQuickAnswersClick também abre o modal de envio.
            handleQuickAnswersClick(opt, { replaceInput: true });
            setTimeout(() => {
              inputRef.current.scrollTop = inputRef.current.scrollHeight;
            }, 200);
            setPopupOpen(false);
          }
        }}
        onInputChange={(event, opt, reason) => {
          if (reason === "input") {
            setInputMessage(opt || "");
          }
        }}
        onPaste={onPaste}
        onKeyPress={onKeyPress}
        style={{ width: "100%" }}
        renderInput={(params) => {
          const { InputLabelProps, InputProps, ...rest } = params;
          return (
            <InputBase
              {...params.InputProps}
              {...rest}
              disabled={disableOption()}
              inputRef={setInputRef}
              placeholder={renderPlaceholder()}
              multiline
              className={classes.messageInput}
              maxRows={5}
            />
          );
        }}
      />
      )}
    </div>
  );
};


  

const MessageInputCustom = (props) => {
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [quickMessageModalOpen, setQuickMessageModalOpen] = useState(false);
  const [documentModalOpen, setDocumentModalOpen] = useState(false);
  const [documentTemplateId, setDocumentTemplateId] = useState(null);
  const [catalogPickerOpen, setCatalogPickerOpen] = useState(false);
  const [aiAgentModalOpen, setAiAgentModalOpen] = useState(false);
    const [quickActionsAnchorEl, setQuickActionsAnchorEl] = useState(null);
    const handleSelectContact = async (contact) => {
        
        setContactModalOpen(false);
        
        const vcardMessage = 
        
        `BEGIN:VCARD
VERSION:3.0
N:;${contact.name};;;
FN:${contact.name}
TEL;type=CELL;waid=${contact.number}:${contact.number}
END:VCARD`;
        
        
          try {
            const queueChoice = await resolveQueueForNewTicket();
            if (!queueChoice.proceed) return;

            await api.post(resolveSendEndpoint(ticketId), {
                read: 1,
                fromMe: true,
                mediaUrl: "",
                userName: user?.name || '',
                body: vcardMessage.trim(),
                quotedMsg: '',
                signMessage: false,
                isVCARD: true,
                contactName: contact.name,
                contactNumber: contact.number,
                // Chat de contato: chamado na conexão do seletor, como o texto.
                ...(preferredWhatsappId ? { whatsappId: preferredWhatsappId } : {}),
                ...(queueChoice.queueId ? { queueId: queueChoice.queueId } : {}),
                ...(forceNewTicket ? { forceNewTicket: true } : {})
              });
          } catch (err) {
            toastError(err);
          }



  };  
  const [openModal, setOpenModal] = useState(false);
  const {
    ticketStatus,
    ticketId,
    ticketUuid,
    // Dono atual do chamado — usado para decidir se o envio deve assumir o ticket.
    ticketUserId = null,
    isGroup,
    contactId,
    // Chamados após um envio bem-sucedido / em erro. O POST é sempre daqui: quem
    // monta o input só reage ao resultado (promover ticket novo, abrir modal de
    // conflito). Ver resolveSendEndpoint.
    onMessageSent,
    onSendError,
    isModal = false,
    // Só a tela de conversa (components/Ticket) liga o "assumir ao enviar"; o chat
    // de contato monta o input sem ticket real e não deve mexer em atribuição.
    assumeOnSend = false,
    onTicketUpdated,
    // Chat de contato depois de "Abrir novo chamado" no aviso de chamado com
    // outro atendente: a rota por contato cria um chamado novo em vez de
    // devolver o conflito de novo.
    forceNewTicket = false,
  } = props;
  // Documentos exigem ticket real (em chat de contato o ticketId vem como "contact-<id>")
  const hasRealTicket = Boolean(ticketId) && !/^contact-/.test(String(ticketId));

  // Caminho único de envio (texto, mídia, áudio, figurinha, vCard): com chamado
  // real vai pela rota do ticket; sem chamado — só acontece no chat de contato —
  // a rota por contato cria o chamado e entrega ao MESMO pipeline no backend.
  // `viaContact`: chamado real de fila sem acesso (ensureTicketOwnershipForSend)
  // — a rota por contato abre um chamado novo do atendente na mesma conexão.
  const resolveSendEndpoint = (ticketIdForSend, viaContact = false) => {
    if (hasRealTicket && !(viaContact && contactId)) {
      return `/messages/${ticketIdForSend}`;
    }

    // Sem o prop contactId, o id do contato ainda vem no pseudo-ticket
    // ("contact-<id>") — postar em /messages/contact-<id> daria 404.
    const inferredContactId =
      typeof ticketId === "string" && /^contact-\d+$/.test(ticketId)
        ? ticketId.replace("contact-", "")
        : undefined;

    return `/messages/contact/${contactId || inferredContactId}`;
  };

  // Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: garantir envio no conector
  // selecionado em chat de contato. Só a rota por contato usa (é ela que cria o
  // chamado); na rota do ticket a conexão já é a do chamado.
  const preferredWhatsappId =
    props.selectedWhatsappId !== "" && props.selectedWhatsappId !== undefined && props.selectedWhatsappId !== null
      ? Number(props.selectedWhatsappId)
      : props.whatsapp?.id
        ? Number(props.whatsapp.id)
        : undefined;
  const classes = useStyles();
  const history = useHistory();

  const [medias, setMedias] = useState([]);
  const [mediaCaption, setMediaCaption] = useState("");
  const [previewErrors, setPreviewErrors] = useState({});
  const [mediaPreviews, setMediaPreviews] = useState([]);
  const [inputMessage, setInputMessage] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sendingText, setSendingText] = useState(false);
  const [recording, setRecording] = useState(false);
  const [recordingPaused, setRecordingPaused] = useState(false);
  // { blob, filename, quotedMsg, url }: áudio gravado que não saiu (ver keepFailedAudio).
  const [failedAudio, setFailedAudio] = useState(null);
  const failedAudioUrl = failedAudio?.url;
  useEffect(() => {
    if (!failedAudioUrl) return undefined;
    return () => URL.revokeObjectURL(failedAudioUrl);
  }, [failedAudioUrl]);
  const [stickerPickerOpen, setStickerPickerOpen] = useState(false);
  const [stickerLibrary, setStickerLibrary] = useState([]);
  const [favoriteStickers, setFavoriteStickers] = useState([]);
  const [loadingStickers, setLoadingStickers] = useState(false);
  const [stickerToDelete, setStickerToDelete] = useState(null);
  const [confirmDeleteStickerOpen, setConfirmDeleteStickerOpen] = useState(false);
  const [deletingSticker, setDeletingSticker] = useState(false);
  const [forbiddenTerms, setForbiddenTerms] = useState([]);
  const [forbiddenWarning, setForbiddenWarning] = useState({ open: false, matches: [] });
  const bypassForbiddenCheckRef = useRef(false);
  // Texto de um botão clicado na conversa que parou no aviso de termo proibido:
  // "Enviar mesmo assim" precisa reenviar ESSE texto, não o rascunho do campo.
  const pendingQuickTextRef = useRef(null);
  const handleSendMessageRef = useRef(null);
  const inputRef = useRef();
  const quickActionsUploadInputRef = useRef(null);
  const sendGuardRef = useRef({
    inFlightSignature: "",
    lastSignature: "",
    lastSentAt: 0,
  });
  const focusInputAtEnd = useCallback(() => {
    const inputElement = inputRef.current;
    if (!inputElement) return;

    inputElement.focus();

    const messageLength = (inputMessage || "").length;
    if (typeof inputElement.setSelectionRange === "function") {
      inputElement.setSelectionRange(messageLength, messageLength);
    }

    if (typeof inputElement.scrollTop === "number") {
      inputElement.scrollTop = inputElement.scrollHeight;
    }
  }, [inputMessage]);

  // Carrega os termos proibidos ativos da empresa para verificar antes de enviar.
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const { data } = await api.get("/forbidden-words/list");
        if (mounted) setForbiddenTerms(Array.isArray(data) ? data : []);
      } catch (err) {
        // Silencioso: falha ao carregar não deve travar o input.
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  const handleCloseForbiddenWarning = useCallback(() => {
    pendingQuickTextRef.current = null;
    setForbiddenWarning({ open: false, matches: [] });
  }, []);

  const handleReplaceForbidden = useCallback(() => {
    // O aviso veio de um botão clicado na conversa: os termos são do texto do
    // botão, não do rascunho — substituir aqui estragaria o que está no campo.
    if (pendingQuickTextRef.current !== null) {
      pendingQuickTextRef.current = null;
      setForbiddenWarning({ open: false, matches: [] });
      return;
    }

    // Calcula o texto já substituído para posicionar o cursor corretamente no
    // FINAL da frase (não usar focusInputAtEnd aqui: seu closure ainda tem o
    // inputMessage antigo, o que jogaria o cursor para o meio do texto novo).
    const newText = applyReplacements(inputMessage, forbiddenWarning.matches);
    setInputMessage(newText);
    setForbiddenWarning({ open: false, matches: [] });
    setTimeout(() => {
      const el = inputRef.current;
      if (!el) return;
      el.focus();
      const end = newText.length;
      if (typeof el.setSelectionRange === "function") {
        el.setSelectionRange(end, end);
      }
      if (typeof el.scrollTop === "number") {
        el.scrollTop = el.scrollHeight;
      }
    }, 0);
  }, [inputMessage, forbiddenWarning.matches]);

  const handleOpenQuickMessageModal = useCallback(() => {
    setQuickMessageModalOpen(true);
  }, []);

  const handleOpenDocumentModal = useCallback((templateId) => {
    setDocumentTemplateId(templateId || null);
    setDocumentModalOpen(true);
  }, []);

  const handleCloseDocumentModal = useCallback(() => {
    setDocumentModalOpen(false);
    setDocumentTemplateId(null);
  }, []);

  const handleCloseQuickMessageModal = useCallback(() => {
    setQuickMessageModalOpen(false);
    setTimeout(() => {
      focusInputAtEnd();
    }, 0);
  }, [focusInputAtEnd]);

  const { setReplyingMessage, replyingMessage, instagramReplyTarget, setInstagramReplyTarget } =
    useContext(ReplyMessageContext);
  const editingContext = useContext(EditingMessageContext);
  const setEditingMessage = editingContext?.setEditingMessage || (() => {});
  const editingMessage = editingContext?.editingMessage || null;
  const { user } = useContext(AuthContext);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { getSetting } = useContext(SettingsContext);
  const { queueMessage } = useContext(PendingMessagesContext);
  const { addOptimisticMessage, removeOptimisticMessage, reassignOptimisticMessage } =
    useContext(OptimisticContext);

  const [signMessage, setSignMessage] = useLocalStorage("signOption", true);
  const [dragActive, setDragActive] = useState(false);
  const mediaUploadInFlightRef = useRef(false);
  const assumeInFlightRef = useRef(false);
  // Popup "Em qual fila abrir o chamado?" (ver resolveQueueForNewTicket).
  const [queueDialogOpen, setQueueDialogOpen] = useState(false);
  const queuePromptRef = useRef(null);
  const chosenQueueRef = useRef({ ticketKey: null, queueId: null });

  // Trocou o chamado da tela (o novo chegou, ou foi resolvido e voltou ao
  // pseudo-ticket "contact-<id>"): a fila escolhida já foi usada. Sem limpar, a
  // próxima conversa nova com o mesmo contato a reaproveitava sem perguntar.
  useEffect(() => {
    chosenQueueRef.current = { ticketKey: null, queueId: null };
  }, [ticketId, ticketStatus]);

  const hasDraggedFiles = useCallback((e) => {
    const types = e?.dataTransfer?.types;
    if (!types) return false;
    return Array.from(types).includes("Files");
  }, []);

  // Cloud API - template dialog when 24h window is closed
  const [templatePickerOpen, setTemplatePickerOpen] = useState(false);
  const [cloudApiTemplates, setCloudApiTemplates] = useState([]);
  const [selectedCloudApiTemplate, setSelectedCloudApiTemplate] = useState("");
  const [cloudApiTemplateVars, setCloudApiTemplateVars] = useState([]);
  const [sendingTemplate, setSendingTemplate] = useState(false);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [groupParticipants, setGroupParticipants] = useState([]);
  const [selectedMentions, setSelectedMentions] = useState([]);
  const draftCacheKey = contactId
    ? `contact-${contactId}`
    : ticketUuid
      ? `ticket-u-${ticketUuid}`
      : ticketId
        ? `ticket-${ticketId}`
        : null;

  // Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: manter o rascunho do input
  // quando ocorrer remount/reload do componente de conversa, evitando perda da segunda mensagem.
  useEffect(() => {
    if (!draftCacheKey) return;
    const cachedDraft = MESSAGE_DRAFT_CACHE.get(draftCacheKey);
    if (typeof cachedDraft === "string") {
      setInputMessage(cachedDraft);
    } else {
      setInputMessage("");
    }
  }, [draftCacheKey]);

  useEffect(() => {
    if (!draftCacheKey) return;
    const normalizedInput = typeof inputMessage === "string" ? inputMessage : "";
    if (normalizedInput) {
      MESSAGE_DRAFT_CACHE.set(draftCacheKey, normalizedInput);
    } else {
      MESSAGE_DRAFT_CACHE.delete(draftCacheKey);
    }
  }, [draftCacheKey, inputMessage]);

  const handleMentionSelected = (mentionOption) => {
    if (!mentionOption?.value) return;

    const numberOnly = String(mentionOption?.participantNumber || "").replace(/\D/g, "");
    const participantJidRaw = String(mentionOption?.participantJid || "").trim();
    const preferredJid = participantJidRaw || (numberOnly.length >= 8
      ? `${numberOnly}@s.whatsapp.net`
      : "");
    const mentionToken = String(mentionOption?.mentionToken || "").trim();

    if (!preferredJid || !mentionToken) return;

    setSelectedMentions((prev) => {
      const next = [...prev, {
        jid: preferredJid,
        token: mentionToken,
        wireToken: String(mentionOption?.mentionWireToken || "").trim() || mentionToken,
        matchTokens: Array.isArray(mentionOption?.mentionMatchTokens)
          ? mentionOption.mentionMatchTokens
          : [mentionToken],
      }];

      const dedupMap = new Map();
      next.forEach((item) => {
        if (item?.jid) dedupMap.set(item.jid, item);
      });
      return Array.from(dedupMap.values());
    });
  };

  const getMentionedJidsForMessage = (messageText) => {
    if (!messageText || selectedMentions.length === 0) return [];

    const mentioned = selectedMentions
      .filter((mention) => {
        const tokens = Array.isArray(mention?.matchTokens) && mention.matchTokens.length > 0
          ? mention.matchTokens
          : [mention?.token];

        return tokens.some((token) => token && messageText.includes(`@${token}`));
      })
      .map((mention) => mention.jid)
      .filter(Boolean);

    return Array.from(new Set(mentioned));
  };

  const escapeRegExp = (value = "") => String(value).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const getMessageWithWireMentionTokens = (messageText) => {
    if (!messageText || selectedMentions.length === 0) return messageText;

    let transformedMessage = String(messageText);

    selectedMentions.forEach((mention) => {
      const wireToken = String(mention?.wireToken || "").trim();
      if (!wireToken) return;

      const candidateTokens = Array.isArray(mention?.matchTokens) && mention.matchTokens.length > 0
        ? mention.matchTokens
        : [mention?.token];

      const normalizedTokens = Array.from(new Set(
        candidateTokens
          .map((token) => String(token || "").trim())
          .filter(Boolean)
      )).sort((a, b) => b.length - a.length);

      normalizedTokens.forEach((token) => {
        // Autor: GitHub Copilot | Data: 12/05/2026 | Motivo: o lookahead `(?=\s|$)`
        // estava sendo interpretado como `(?=s|$)` em template literal porque o `\`
        // era consumido pela string. Sem isso, a menção só era reescrita quando
        // não havia texto depois (ou quando seguida da letra "s"), deixando de
        // virar JID quando o usuário digitava "@Fulano teste". Use `\\s` para
        // gerar o regex correto e também aceite limites como pontuação comum.
        const pattern = new RegExp(`@${escapeRegExp(token)}(?=$|[\\s.,;:!?\\-\\)\\]\\}'"\\u00a0])`, "g");
        transformedMessage = transformedMessage.replace(pattern, `@${wireToken}`);
      });
    });

    return transformedMessage;
  };

  useEffect(() => {
    // Abortada ao trocar de grupo: sem isso a resposta do grupo anterior podia
    // chegar depois e sobrescrever os participantes do atual.
    const abortController = new AbortController();
    const loadGroupParticipants = async () => {
      if (!isGroup || !contactId) {
        setGroupParticipants([]);
        return;
      }

      try {
        const { data } = await api.get(`/contacts/${contactId}/participants`, {
          signal: abortController.signal,
        });
        if (abortController.signal.aborted) return;
        setGroupParticipants(Array.isArray(data?.participants) ? data.participants : []);
      } catch (_err) {
        if (abortController.signal.aborted) return;
        setGroupParticipants([]);
      }
    };

    loadGroupParticipants();
    return () => abortController.abort();
  }, [isGroup, contactId, ticketId]);

  // === Cloud API Template Dialog Handlers ===
  const getTemplateVariables = (template) => {
    const ordered = [];
    const addVars = (text) => {
      extractVariables(text || "").forEach((v) => {
        if (!ordered.includes(v)) {
          ordered.push(v);
        }
      });
    };

    if (template?.components?.length) {
      template.components.forEach((comp) => {
        const compType = String(comp.type || "").toUpperCase();
        const compFormat = String(comp.format || "").toUpperCase();
        if (compType === "BODY") {
          addVars(comp.text || template.bodyText || "");
        }
        if (compType === "HEADER" && compFormat === "TEXT") {
          addVars(comp.text || "");
        }
        if ((compType === "BUTTONS" || compType === "BUTTON") && Array.isArray(comp.buttons)) {
          comp.buttons.forEach((btn) => {
            const btnType = String(btn.type || "").toUpperCase();
            if (btnType === "URL") {
              addVars(btn.url || "");
            }
          });
        }
      });
    } else {
      addVars(template?.bodyText || "");
    }

    return ordered;
  };

  const handleOpenTemplatePicker = async () => {
    setLoadingTemplates(true);
    setTemplatePickerOpen(true);
    try {
      const selectedWhatsapp = Array.isArray(props.whatsapps)
        ? props.whatsapps.find((w) => Number(w.id) === Number(props.selectedWhatsappId))
        : null;

      const whatsapp = props.whatsapp || selectedWhatsapp;
      if (!whatsapp) return;
      // Usar wabaId para carregar templates compartilhados entre números da mesma conta
      const queryParams = whatsapp.cloudApiBusinessAccountId
        ? { wabaId: whatsapp.cloudApiBusinessAccountId }
        : { whatsappId: whatsapp.id };
      const { data } = await api.get("/message-templates", {
        params: queryParams,
      });
      setCloudApiTemplates(
        (data.templates || data).filter((t) => t.status === "APPROVED")
      );
    } catch (err) {
      toastError(err);
    } finally {
      setLoadingTemplates(false);
    }
  };

  const handleSelectCloudApiTemplate = (templateId) => {
    setSelectedCloudApiTemplate(templateId);
    const template = cloudApiTemplates.find((t) => t.id === parseInt(templateId));
    if (template) {
      const varsList = getTemplateVariables(template);
      const vars = varsList.map((v) => ({ name: v, value: "" }));
      setCloudApiTemplateVars(vars);
    } else {
      setCloudApiTemplateVars([]);
    }
  };

  const handleSendCloudApiTemplate = async () => {
    if (!selectedCloudApiTemplate) return;
    setSendingTemplate(true);
    try {
      let variables = undefined;
      if (cloudApiTemplateVars.length > 0) {
        variables = cloudApiTemplateVars.map((v) => v.value || "");
      }

      const selectedWhatsapp = Array.isArray(props.whatsapps)
        ? props.whatsapps.find((w) => Number(w.id) === Number(props.selectedWhatsappId))
        : null;

      const whatsappForTemplate = props.whatsapp || selectedWhatsapp;
      const isContactChatWithoutTicket = !!contactId && (!ticketId || String(ticketId).startsWith("contact-"));

      const payload = { variables };

      if (isContactChatWithoutTicket) {
        const queueChoice = await resolveQueueForNewTicket();
        if (!queueChoice.proceed) return;

        payload.contactId = contactId;
        payload.whatsappId = whatsappForTemplate?.id || undefined;
        if (queueChoice.queueId) payload.queueId = queueChoice.queueId;
      } else {
        payload.ticketId = ticketId;
      }

      const { data } = await api.post(`/message-templates/${selectedCloudApiTemplate}/send`, payload);

      toast.success(i18n.t("messagesInput.cloudApi.templateSent"));
      setTemplatePickerOpen(false);
      setSelectedCloudApiTemplate("");
      setCloudApiTemplateVars([]);

      if (isContactChatWithoutTicket && data?.ticket?.uuid) {
        if (typeof props.onTicketCreated === "function") {
          props.onTicketCreated(data.ticket.uuid);
        } else {
          history.push(`/tickets/${data.ticket.uuid}`);
        }
      }
    } catch (err) {
      toastError(err);
    } finally {
      setSendingTemplate(false);
    }
  };

  const handleAcceptTicket = async () => {
    setLoading(true);
    try {
      // Buscar dados do ticket para verificar a fila
      const { data: ticket } = await api.get(`/tickets/${ticketId}`);
      
      // Verificar se o ticket tem fila e se o usuário tem acesso a ela
      if (ticket.queueId) {
        const userQueueIds = user.queues.map((q) => q.id);
        if (!userQueueIds.includes(ticket.queueId)) {
          setLoading(false);
          toastError(i18n.t("messagesInput.errors.noQueueAccess"));
          return;
        }
      }
      
      await api.put(`/tickets/${ticketId}`, {
        status: "open",
        userId: user?.id,
      });
      setLoading(false);
      // Não precisa fazer nada - o socket atualizará automaticamente
      // e o ticket já está aberto na tela
    } catch (err) {
      setLoading(false);
      toastError(err);
    }
  };

  // Ticket aberto do mesmo contato — usado quando a reabertura esbarra na
  // unificação de conversas (ERR_OTHER_OPEN_TICKET) fora do modal. No modo "um
  // por conexão" só conta o da mesma conexão: o de outra é conversa de outro número.
  const findOpenTicketIdForContact = async () => {
    if (!ticketUuid && !ticketId) return null;

    const endpoint = ticketUuid ? `/tickets/u/${ticketUuid}` : `/tickets/${ticketId}`;
    const { data: currentTicketData } = await api.get(endpoint);

    const { data: openTickets } = await api.get("/tickets", {
      params: {
        contactId: currentTicketData.contactId,
        status: "open",
        pageNumber: 1,
      },
    });

    const candidates =
      isPerConnectionContactTickets(getSetting) && isPerConnectionContact(currentTicketData.contact)
        ? (openTickets?.tickets || []).filter(
            (t) => Number(t.whatsappId) === Number(currentTicketData.whatsappId)
          )
        : openTickets?.tickets || [];

    return candidates.length ? candidates[0].id : null;
  };

  // Autor: Claude | Data: 23/07/2026 | Motivo: quem responde o chamado precisa virar
  // o dono dele — inclusive pela tela de Pendentes, que abre a conversa em modal e
  // até então enviava sem assumir (o cabeçalho seguia com quem criou a pendência).
  //
  // Regras: `pending` assume; `closed` reabre e assume; `open` sem dono só recebe o
  // dono (não pode passar pelo caminho de reabertura); `open` de outro atendente ou
  // já do próprio usuário não é tocado.
  //
  // Retorna { proceed, ticketId, warning }: `proceed: false` aborta o envio.
  const ensureTicketOwnershipForSend = async () => {
    const noop = { proceed: true, ticketId, warning: "" };

    if (!assumeOnSend || !hasRealTicket || !user?.id) return noop;
    // Um assumir em andamento já resolve o ticket para as mensagens seguintes.
    if (assumeInFlightRef.current) return noop;

    // `open` com dono (o próprio ou outro atendente) é o único caso que não mexe
    // em nada: quando é de outro, o input já fica bloqueado com "Assumir chamado".
    // `closed` reabre mesmo sendo do próprio usuário.
    const needsAssume =
      ticketStatus === "pending" ||
      ticketStatus === "closed" ||
      (ticketStatus === "open" && !ticketUserId);

    if (!needsAssume) return noop;

    assumeInFlightRef.current = true;
    try {
      // `queueId` fica FORA do payload de propósito: todas as condições que
      // disparam a mensagem automática de transferência para o cliente
      // (setting `sendMsgTransfTicket`) dependem dele.
      const { data } = await api.put(`/tickets/${ticketId}`, {
        status: "open",
        userId: user.id,
        transferredBy: user.id,
      });

      onTicketUpdated?.(data);
      return noop;
    } catch (err) {
      const code = err?.response?.data?.error;
      console.warn("[MessageInput] Erro ao assumir chamado no envio:", code);

      // Chamado de conexão excluída: só leitura. Não reabre nem desvia a mensagem
      // para a rota por contato.
      if (code === "ERR_TICKET_INACTIVE") {
        toastError(err);
        return { proceed: false, ticketId, warning: "" };
      }

      // Chamado de fila a que o atendente não tem acesso: não assume nem perde
      // a mensagem. Vai pela rota por contato, que abre um chamado novo dele na
      // mesma conexão (fila dele ou sem fila) e deixa este onde está. No modo
      // "um por conexão" não existe segundo chamado na mesma conexão: o backend
      // bloquearia de novo, então mostra o erro e para.
      if (
        code === "ERR_USER_NO_QUEUE_ACCESS" &&
        contactId &&
        !isPerConnectionContactTickets(getSetting)
      ) {
        return {
          proceed: true,
          ticketId,
          viaContact: true,
          warning: i18n.t("messagesInput.errors.noQueueAccessNewTicket"),
        };
      }

      if (code === "ERR_OTHER_OPEN_TICKET") {
        // No modal (tela de Pendentes) a mensagem vai no chamado que está na
        // tela, sem reabrir e sem redirecionar para outro ticket.
        if (isModal) {
          return {
            proceed: true,
            ticketId,
            warning: i18n.t("messagesInput.errors.otherOpenTicketSentHere"),
          };
        }

        try {
          const openTicketId = await findOpenTicketIdForContact();
          if (openTicketId) {
            return { proceed: true, ticketId: openTicketId, warning: "" };
          }
        } catch (searchErr) {
          console.error("[MessageInput] Erro ao buscar ticket aberto:", searchErr);
        }
      }

      toastError(err);
      return { proceed: false, ticketId, warning: "" };
    } finally {
      assumeInFlightRef.current = false;
    }
  };

  // Envio que abriu chamado novo pela rota por contato a partir da tela de um
  // chamado de fila sem acesso: leva o atendente para o chamado novo (no modal
  // da tela de Pendentes fica o aviso).
  const followViaContactTicket = (ownership, data) => {
    if (!ownership?.viaContact || !data?.ticket?.uuid || isModal) return;
    history.push(`/tickets/${data.ticket.uuid}`);
  };

  // Fila do chamado que a rota por contato vai criar (só no chat de contato sem
  // chamado). Uma fila → ela; várias → pergunta no popup; nenhuma → o backend
  // decide como antes. A escolha vale para os envios seguintes do mesmo
  // pseudo-ticket, enquanto o chamado novo não chega na tela.
  //
  // Retorna { proceed, queueId }: `proceed: false` = atendente cancelou o popup.
  const resolveQueueForNewTicket = () => {
    const userQueues = Array.isArray(user?.queues) ? user.queues : [];

    if (hasRealTicket || userQueues.length === 0) {
      return Promise.resolve({ proceed: true, queueId: undefined });
    }
    if (userQueues.length === 1) {
      return Promise.resolve({ proceed: true, queueId: userQueues[0].id });
    }

    const remembered = chosenQueueRef.current;
    if (
      remembered.ticketKey === String(ticketId) &&
      userQueues.some((q) => Number(q.id) === Number(remembered.queueId))
    ) {
      return Promise.resolve({ proceed: true, queueId: remembered.queueId });
    }

    // Um popup por vez: um segundo envio enquanto ele está aberto é descartado.
    if (queuePromptRef.current) {
      return Promise.resolve({ proceed: false, queueId: undefined });
    }

    return new Promise((resolve) => {
      queuePromptRef.current = resolve;
      setQueueDialogOpen(true);
    });
  };

  const settleQueuePrompt = (result) => {
    setQueueDialogOpen(false);
    const resolve = queuePromptRef.current;
    queuePromptRef.current = null;
    resolve?.(result);
  };

  const handleQueueDialogSelect = (queueId) => {
    chosenQueueRef.current = { ticketKey: String(ticketId), queueId };
    settleQueuePrompt({ proceed: true, queueId });
  };

  const handleQueueDialogClose = () => {
    settleQueuePrompt({ proceed: false, queueId: undefined });
  };

  useEffect(() => {
    const handleWindowDragEnter = (e) => {
      if (!hasDraggedFiles(e)) return;
      e.preventDefault();
      setDragActive(true);
    };

    const handleWindowDragOver = (e) => {
      if (!hasDraggedFiles(e)) return;
      e.preventDefault();
      setDragActive(true);
    };

    const handleWindowDragLeave = (e) => {
      if (e.relatedTarget !== null) return;
      setDragActive(false);
    };

    const handleWindowDrop = (e) => {
      if (!hasDraggedFiles(e)) return;
      e.preventDefault();
      setDragActive(false);
    };

    window.addEventListener("dragenter", handleWindowDragEnter);
    window.addEventListener("dragover", handleWindowDragOver);
    window.addEventListener("dragleave", handleWindowDragLeave);
    window.addEventListener("drop", handleWindowDrop);

    return () => {
      window.removeEventListener("dragenter", handleWindowDragEnter);
      window.removeEventListener("dragover", handleWindowDragOver);
      window.removeEventListener("dragleave", handleWindowDragLeave);
      window.removeEventListener("drop", handleWindowDrop);
    };
  }, [hasDraggedFiles]);
  useEffect(() => {
    if (!templatePickerOpen) {
      inputRef.current?.focus();
    }
  }, [replyingMessage, templatePickerOpen]);

  useEffect(() => {
    if (!templatePickerOpen) {
      inputRef.current?.focus();
    }
    // Se há uma mensagem sendo editada, coloca o texto no input
    if (editingMessage) {
      setInputMessage(editingMessage.body);
    }
  }, [editingMessage, templatePickerOpen]);

  useEffect(() => {
    if (!templatePickerOpen) {
      inputRef.current?.focus();
    }
  }, [ticketId, templatePickerOpen]);

  useEffect(() => {
    setShowEmoji(false);
    setMedias([]);
    setReplyingMessage(null);
  }, [ticketId, setReplyingMessage]);

  useEffect(() => {
    const previews = medias.map((media, index) => ({
      key: `${media.name}-${media.size}-${media.lastModified}-${index}`,
      url: URL.createObjectURL(media),
    }));

    setMediaPreviews(previews);
    setPreviewErrors({});

    return () => {
      previews.forEach((preview) => {
        URL.revokeObjectURL(preview.url);
      });
    };
  }, [medias]);

  useEffect(() => {
    if (templatePickerOpen) return;

    const pendingRaw = localStorage.getItem(PENDING_PRIVATE_REPLY_KEY);
    if (!pendingRaw) return;

    try {
      const pending = JSON.parse(pendingRaw);
      const matchesTicketId = pending?.ticketId && Number(pending.ticketId) === Number(ticketId);
      const matchesTicketUuid = pending?.ticketUuid && ticketUuid && pending.ticketUuid === ticketUuid;

      if ((matchesTicketId || matchesTicketUuid) && pending?.message) {
        setReplyingMessage(pending.message);
        localStorage.removeItem(PENDING_PRIVATE_REPLY_KEY);
      }
    } catch (err) {
      localStorage.removeItem(PENDING_PRIVATE_REPLY_KEY);
    }
  }, [ticketId, ticketUuid, templatePickerOpen, setReplyingMessage]);


  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    if (!hasDraggedFiles(e)) {
      return;
    }

    try {
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length > 0) {
        // Cria um "evento sintético" com a mesma estrutura que o onChange do input file
        const syntheticEvent = { target: { files: e.dataTransfer.files } };
        handleChangeMedias(syntheticEvent);
      }
    } catch (_err) {
      // Evita quebrar a tela em conflitos de drag/drop do navegador com elementos de input.
    }
  };

  const handleDragEnter = (e) => {
    if (!hasDraggedFiles(e)) return;
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragOver = (e) => {
    if (!hasDraggedFiles(e)) return;
    e.stopPropagation();
    e.preventDefault();
    setDragActive(true);
  };

  const handleDragLeave = (e) => {
    if (!hasDraggedFiles(e)) return;
    e.preventDefault();
    if (e.currentTarget.contains(e.relatedTarget)) {
      return;
    }
    setDragActive(false);
  };

  // const handleChangeInput = e => {
  // 	if (isObject(e) && has(e, 'value')) {
  // 		setInputMessage(e.value);
  // 	} else {
  // 		setInputMessage(e.target.value)
  // 	}
  // };

  const handleAddEmoji = (e) => {
    let emoji = e.native;
    setInputMessage((prevState) => prevState + emoji);
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setMedias((prevMedias) => [...prevMedias, ...selectedMedias]);

    if (typeof e.target.value === "string") {
      e.target.value = "";
    }
  };

  useEffect(() => {
    const handleConversationFileDrop = (event) => {
      const droppedFiles = Array.isArray(event?.detail?.files)
        ? event.detail.files
        : [];

      if (droppedFiles.length === 0) return;

      const syntheticEvent = { target: { files: droppedFiles } };
      handleChangeMedias(syntheticEvent);
    };

    window.addEventListener("onspace:conversation-file-drop", handleConversationFileDrop);

    return () => {
      window.removeEventListener("onspace:conversation-file-drop", handleConversationFileDrop);
    };
  }, []);

  const handleInputPaste = (e) => {
    const pastedFiles = e.clipboardData?.files ? Array.from(e.clipboardData.files) : [];

    if (pastedFiles.length > 0) {
      e.preventDefault();
      setMedias((prevMedias) => [...prevMedias, ...pastedFiles]);
    }
  };

  const handleRemoveMedia = (indexToRemove) => {
    setMedias((prevMedias) => prevMedias.filter((_, index) => index !== indexToRemove));
  };

  const getMediaKind = (media) => {
    const mimeType = media?.type || "";
    if (mimeType.startsWith("image/")) return "image";
    if (mimeType.startsWith("video/")) return "video";
    return "document";
  };

  const renderFileTypeIcon = (media) => {
    const mimeType = String(media?.type || "").toLowerCase();
    const fileName = String(media?.name || "").toLowerCase();

    if (mimeType.includes("pdf") || fileName.endsWith(".pdf")) {
      return <PictureAsPdfIcon fontSize="large" color="action" />;
    }

    if (mimeType.startsWith("audio/")) {
      return <AudiotrackIcon fontSize="large" color="action" />;
    }

    if (
      mimeType.includes("zip") ||
      mimeType.includes("rar") ||
      mimeType.includes("7z") ||
      fileName.endsWith(".zip") ||
      fileName.endsWith(".rar") ||
      fileName.endsWith(".7z")
    ) {
      return <ArchiveIcon fontSize="large" color="action" />;
    }

    if (mimeType.startsWith("image/")) {
      return <ImageIcon fontSize="large" color="action" />;
    }

    if (mimeType.startsWith("video/")) {
      return <MovieIcon fontSize="large" color="action" />;
    }

    return <InsertDriveFileIcon fontSize="large" color="action" />;
  };

  const handleQuickAnswersClick = async (value, { replaceInput = false } = {}) => {
    // Resposta rápida vinculada a um modelo de documento: abre o modal de envio
    if (value.documentTemplateId) {
      handleOpenDocumentModal(value.documentTemplateId);
    }

    const anexos = getQuickMessageMedias(value);

    if (anexos.length > 0) {
      // Carrega TODOS os anexos na área de preview (com legenda editável) em vez de
      // enviar imediatamente, permitindo ao atendente revisar/editar antes do envio.
      // allSettled e não all: há anexos antigos apontando para arquivos que já não
      // existem, e um 404 não pode derrubar os demais anexos da mesma resposta.
      const resultados = await Promise.allSettled(
        anexos.map(async (anexo) => {
          const { data } = await axios.get(anexo.mediaPath, {
            responseType: "blob",
          });

          const fallbackName =
            String(anexo.mediaPath).split(/[/\\?#]/).filter(Boolean).pop() || "arquivo";

          return new File([data], anexo.mediaName || fallbackName, {
            type: anexo.mediaType || data.type,
          });
        })
      );

      const arquivos = resultados
        .filter((r) => r.status === "fulfilled")
        .map((r) => r.value);
      const falhas = resultados.length - arquivos.length;

      if (arquivos.length > 0) {
        setMedias((prevMedias) => [...prevMedias, ...arquivos]);
        setMediaCaption(value.value || "");
        setInputMessage("");
        if (falhas > 0) {
          toast.warn(i18n.t("quickMessages.attachments.notFound"));
        }
        return;
      }

      if (falhas > 0) {
        toast.warn(i18n.t("quickMessages.attachments.notFound"));
      }
      // Nenhum anexo pôde ser baixado: segue para o fluxo de texto abaixo.
    }

    // Concatena a mensagem rápida ao texto existente (botão ⚡). Quando a seleção vem
    // do atalho "/x" digitado no input, replaceInput substitui o comando pelo texto.
    setInputMessage(prevMessage => {
      if (!replaceInput && prevMessage && prevMessage.trim()) {
        return prevMessage + '\n' + value.value;
      }
      return value.value;
    });
  };

  const handleUploadMedia = async (e) => {
    // Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: evitar reentrada que dispara
    // o mesmo envio de mídia múltiplas vezes (Enter/clique repetido antes do estado atualizar).
    if (mediaUploadInFlightRef.current || loading || medias.length === 0) {
      if (e?.preventDefault) {
        e.preventDefault();
      }
      return;
    }

    mediaUploadInFlightRef.current = true;
    setLoading(true);
    if (e?.preventDefault) {
      e.preventDefault();
    }
    // Congela a citação antes de qualquer await (igual ao handleSendMessage):
    // um clique em "Responder" durante o upload não pode trocar o alvo.
    const currentQuotedMsg = replyingMessage;

    // Cancelar o popup de fila mantém os anexos para o atendente tentar de novo.
    const queueChoice = await resolveQueueForNewTicket();
    if (!queueChoice.proceed) {
      mediaUploadInFlightRef.current = false;
      setLoading(false);
      return;
    }

    // Usar a legenda digitada pelo usuário, ou vazio se não tiver
    const caption = mediaCaption.trim();
    const mediasToSend = medias;

    // `extra` entra no reenvio pedido pelo aviso de chamado com outro atendente
    // ({ forceNewTicket: true }).
    const buildFormData = (extra = {}) => {
      const formData = new FormData();
      formData.append("fromMe", true);
      formData.append("signMessage", signMessage ? "true" : "false");
      formData.append("userName", user?.name || "");
      // Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: garantir envio no conector selecionado em chat de contato.
      if (preferredWhatsappId) {
        formData.append("whatsappId", String(preferredWhatsappId));
      }
      if (queueChoice.queueId) {
        formData.append("queueId", String(queueChoice.queueId));
      }
      if (forceNewTicket || extra.forceNewTicket) {
        formData.append("forceNewTicket", "true");
      }
      // Campos de texto antes dos arquivos: o multer lê req.body durante o stream.
      if (currentQuotedMsg?.id) {
        formData.append("quotedMsgId", String(currentQuotedMsg.id));
      }

      // Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: comportamento igual ao WhatsApp Web
      // (legenda somente na primeira midia quando ha envio multiplo).
      mediasToSend.forEach((media, index) => {
        formData.append("medias", media);
        formData.append("body", index === 0 ? (caption || "") : ""); // Apenas a primeira midia recebe legenda
      });
      return formData;
    };

    // Só limpa no sucesso: em caso de erro os anexos, a legenda e a citação
    // ficam para o atendente reenviar.
    const clearSentMedias = () => {
      setReplyingMessage(null);
      setMedias([]);
      setMediaCaption("");
    };

    let ownership = null;
    try {
      // Mesma regra do texto: quem envia assume o chamado. Assumir antes do POST
      // também garante que a rota por contato reaproveite ESTE ticket (ela busca
      // o ticket open do próprio usuário) em vez de cair em outro do contato.
      ownership = await ensureTicketOwnershipForSend();
      if (!ownership.proceed) {
        return;
      }
      if (ownership.warning) {
        toast.warn(ownership.warning);
      }

      const { data } = await api.post(
        resolveSendEndpoint(ownership.ticketId, ownership.viaContact),
        buildFormData(),
        { timeout: MEDIA_UPLOAD_TIMEOUT_MS }
      );
      clearSentMedias();
      // Igual ao texto: o chat de contato promove o chamado recém-criado.
      onMessageSent?.(data);
      followViaContactTicket(ownership, data);
    } catch (err) {
      const code = err?.response?.data?.error;
      if (code === 'ERR_CLOUDAPI_WINDOW_CLOSED') {
        clearSentMedias();
        handleOpenTemplatePicker();
      } else {
        const retry = async (extra = {}) => {
          const { data } = await api.post(
            resolveSendEndpoint(ownership?.ticketId ?? ticketId, ownership?.viaContact),
            buildFormData(extra),
            { timeout: MEDIA_UPLOAD_TIMEOUT_MS }
          );
          clearSentMedias();
          onMessageSent?.(data);
          return data;
        };
        if (!onSendError?.(err, { retry })) {
          toastError(err);
        }
      }
    } finally {
      mediaUploadInFlightRef.current = false;
      setLoading(false);
    }
  };

  const loadStickerLibrary = async () => {
    setLoadingStickers(true);
    try {
      const { data } = await api.get("/messages/stickers/library", {
        params: { limit: 120, includeReceived: true },
      });
      setStickerLibrary(Array.isArray(data?.stickers) ? data.stickers : []);
    } catch (err) {
      toastError(err);
    } finally {
      setLoadingStickers(false);
    }
  };

  const loadStickerFavorites = async () => {
    try {
      const { data } = await api.get("/messages/stickers/favorites");
      setFavoriteStickers(Array.isArray(data?.favorites) ? data.favorites : []);
    } catch (err) {
      toastError(err);
    }
  };

  const isFavoriteSticker = (mediaUrl) => favoriteStickers.includes(mediaUrl);

  const handleToggleStickerFavorite = async (mediaUrl) => {
    try {
      if (isFavoriteSticker(mediaUrl)) {
        const { data } = await api.delete("/messages/stickers/favorites", { data: { mediaUrl } });
        setFavoriteStickers(Array.isArray(data?.favorites) ? data.favorites : []);
      } else {
        const { data } = await api.post("/messages/stickers/favorites", { mediaUrl });
        setFavoriteStickers(Array.isArray(data?.favorites) ? data.favorites : []);
      }
    } catch (err) {
      toastError(err);
    }
  };

  // Espelha normalizeStickerKey do backend: a mesma figurinha pode estar salva nos
  // favoritos com um BACKEND_URL antigo e na biblioteca com o atual.
  const normalizeStickerKey = (value) => {
    const raw = String(value || "").trim().replace(/\\/g, "/").split("?")[0];
    if (!raw) return "";
    const publicIndex = raw.indexOf("/public/");
    if (publicIndex >= 0) return raw.substring(publicIndex + 8).replace(/^\/+/, "");
    if (/^https?:\/\//i.test(raw)) return raw;
    return raw.replace(/^\/+/, "");
  };

  const handleAskRemoveStickerFromLibrary = (mediaUrl) => {
    setStickerToDelete(mediaUrl);
    setConfirmDeleteStickerOpen(true);
  };

  const handleRemoveStickerFromLibrary = async () => {
    const mediaUrl = stickerToDelete;
    if (!mediaUrl) return;

    setDeletingSticker(true);
    try {
      const { data } = await api.delete("/messages/stickers/library", { data: { mediaUrl } });
      const removedKey = normalizeStickerKey(mediaUrl);

      setStickerLibrary((prev) =>
        prev.filter((item) => normalizeStickerKey(item.mediaUrl) !== removedKey)
      );

      if (Array.isArray(data?.favorites)) {
        setFavoriteStickers(data.favorites);
      } else {
        setFavoriteStickers((prev) =>
          prev.filter((item) => normalizeStickerKey(item) !== removedKey)
        );
      }

      toast.success(i18n.t("messagesInput.stickers.removed"));
    } catch (err) {
      toastError(err);
    } finally {
      setDeletingSticker(false);
      setStickerToDelete(null);
    }
  };

  const sendStickerFile = async (file) => {
    // Congela a citação antes de qualquer await (igual ao handleSendMessage).
    const currentQuotedMsg = replyingMessage;

    const queueChoice = await resolveQueueForNewTicket();
    if (!queueChoice.proceed) return;

    const formData = new FormData();
    formData.append("fromMe", true);
    formData.append("body", "");
    formData.append("medias", file, file.name || `sticker_${Date.now()}.webp`);
    formData.append("isSticker", "true");
    // Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: garantir envio no conector selecionado em chat de contato.
    if (preferredWhatsappId) {
      formData.append("whatsappId", String(preferredWhatsappId));
    }
    if (queueChoice.queueId) {
      formData.append("queueId", String(queueChoice.queueId));
    }
    if (forceNewTicket) {
      formData.append("forceNewTicket", "true");
    }
    if (currentQuotedMsg?.id) {
      formData.append("quotedMsgId", String(currentQuotedMsg.id));
    }

    // Figurinha também é mensagem do atendente: mesma regra de atribuição.
    const ownership = await ensureTicketOwnershipForSend();
    if (!ownership.proceed) {
      return;
    }
    if (ownership.warning) {
      toast.warn(ownership.warning);
    }

    const { data } = await api.post(
      resolveSendEndpoint(ownership.ticketId, ownership.viaContact),
      formData,
      { timeout: MEDIA_UPLOAD_TIMEOUT_MS }
    );
    followViaContactTicket(ownership, data);

    // Só limpa no sucesso: em caso de erro o atendente reenvia mantendo a citação.
    setReplyingMessage(null);
  };

  const handleOpenStickerPicker = async () => {
    setStickerPickerOpen(true);
    await Promise.all([loadStickerLibrary(), loadStickerFavorites()]);
  };

  const handleSendStickerFromLibrary = async (sticker) => {
    setLoading(true);
    try {
      const { data } = await axios.get(sticker.mediaUrl, { responseType: "blob" });
      const file = new File([data], `sticker_${Date.now()}.webp`, { type: "image/webp" });
      await sendStickerFile(file);
      setStickerPickerOpen(false);
    } catch (err) {
      const code = err?.response?.data?.error;
      if (code === "ERR_CLOUDAPI_WINDOW_CLOSED") {
        handleOpenTemplatePicker();
      } else {
        toastError(err);
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePullStickersFromWhatsApp = async () => {
    if (!ticketId) {
      toastError(i18n.t("messagesInput.stickers.openTicketToPull"));
      return;
    }

    setLoadingStickers(true);
    try {
      const { data } = await api.post("/messages/stickers/sync", {
        ticketId,
        whatsappId: props.whatsapp?.id,
      });
      setStickerLibrary(Array.isArray(data?.stickers) ? data.stickers : []);
      const count = Array.isArray(data?.stickers) ? data.stickers.length : 0;
      toast.success(i18n.t("messagesInput.stickers.pulled", { count }));
    } catch (err) {
      toastError(err);
    } finally {
      setLoadingStickers(false);
    }
  };

  const handleSendMessage = async (overrideText) => {
    // Texto de um botão/linha de lista clicado na conversa (evento
    // "onspace:send-quick-text"). Segue o mesmo fluxo do texto digitado, mas sai
    // sem assinatura (o robô do outro lado casa o texto da opção), sem citação e
    // sem mexer no rascunho, na resposta ou na edição que o atendente tenha em
    // andamento. O `typeof` importa: este handler também é ligado direto em
    // onClick, que passa o evento.
    const isQuickText = typeof overrideText === "string";
    const sourceText = isQuickText ? overrideText : inputMessage;

    if (sourceText.trim() === "") return;
    if (isQuickText && (loading || sendingText || recording)) return;

    // Verificação de termos proibidos (só mensagens de atendente humano passam por
    // aqui; mensagens de IA são geradas no backend e nunca chegam neste componente).
    // "Enviar mesmo assim" seta bypassForbiddenCheckRef para pular esta checagem.
    if (!bypassForbiddenCheckRef.current) {
      const matches = detectForbiddenTerms(sourceText, forbiddenTerms);
      if (matches.length > 0) {
        pendingQuickTextRef.current = isQuickText ? overrideText : null;
        setForbiddenWarning({ open: true, matches });
        return;
      }
    }
    bypassForbiddenCheckRef.current = false;

    const replyTarget = isQuickText ? null : replyingMessage;
    const currentSignature = `${contactId || ticketId || ticketUuid || ""}|${sourceText.trim()}|${replyTarget?.id || ""}`;
    const now = Date.now();
    if (sendGuardRef.current.inFlightSignature === currentSignature) {
      return;
    }
    if (
      sendGuardRef.current.lastSignature === currentSignature &&
      now - sendGuardRef.current.lastSentAt < 1200
    ) {
      return;
    }

    // Edição tem prioridade sobre qualquer caminho de envio novo (Cloud API/otimista).
    // Sem isto, ao editar dentro do ContactChat a edição virava mensagem nova.
    if (editingMessage && !isQuickText) {
      try {
        await api.put(`/messages/${editingMessage.id}`, {
          body: inputMessage.trim()
        });

        setInputMessage("");
        setShowEmoji(false);
        setEditingMessage(null);
      } catch (err) {
        toastError(err);
      }
      return;
    }

    // Cloud API: se janela de 24h expirada, abrir template picker diretamente
    if (isCloudApiWindowClosed) {
      handleOpenTemplatePicker();
      return;
    }

    // Chat de contato sem chamado: a fila é escolhida antes da mensagem otimista,
    // então cancelar o popup deixa o texto no input sem nada na conversa.
    const queueChoice = await resolveQueueForNewTicket();
    if (!queueChoice.proceed) return;

    // CRIAR MENSAGEM OTIMISTA IMEDIATAMENTE (não espera resposta do backend)
    const currentMessage = sourceText.trim();
    const wireMessage = isQuickText ? currentMessage : getMessageWithWireMentionTokens(currentMessage);
    const currentQuotedMsg = replyTarget;
    const mentionedJids = isQuickText ? [] : getMentionedJidsForMessage(currentMessage);
    const useSignature = isQuickText ? false : signMessage;
    sendGuardRef.current.inFlightSignature = currentSignature;
    sendGuardRef.current.lastSignature = currentSignature;
    sendGuardRef.current.lastSentAt = Date.now();
    setSendingText(true);
    const optimisticId = addOptimisticMessage(ticketId, {
      body: currentMessage,
      quotedMsg: currentQuotedMsg,
      userName: user?.name || '',
      signMessage: useSignature
    });

    // Limpar input IMEDIATAMENTE para permitir digitação da próxima mensagem
    if (!isQuickText) {
      setInputMessage("");
      setShowEmoji(false);
      setReplyingMessage(null);
      setSelectedMentions([]);
    }

    // Enviar ao backend em background (não bloqueia a UI)
    (async () => {
      // Autor: GitHub Copilot | Data: 16/04/2026 | Motivo: `finalTicketId`
      // precisa existir também no `catch` para enfileirar retry no ticket correto.
      let finalTicketId = ticketId;
      // Rota e corpo do POST, para o reenvio pedido pelo aviso de chamado com
      // outro atendente (onSendError → retry).
      let sentRequest = null;
      try {
        console.log('[MessageInput] Enviando mensagem:', { ticketId, ticketUuid, ticketStatus, isModal, messageLength: currentMessage.length });

        // Quem envia assume o chamado (reabrindo quando fechado). Falhar aqui
        // aborta o envio: a mensagem otimista sai da lista e o texto volta para
        // o input, para o atendente resolver a pendência e reenviar.
        const ownership = await ensureTicketOwnershipForSend();
        if (!ownership.proceed) {
          removeOptimisticMessage(ticketId, optimisticId);
          if (!isQuickText) {
            setInputMessage((prev) => (prev ? prev : currentMessage));
          }
          return;
        }
        finalTicketId = ownership.ticketId;
        if (ownership.warning) {
          toast.warn(ownership.warning);
        }

        const message = {
          read: 1,
          fromMe: true,
          mediaUrl: "",
          userName: user?.name || '',
          body: wireMessage,
          displayBody: currentMessage,
          quotedMsg: currentQuotedMsg,
          signMessage: useSignature,
          mentionedJids,
          optimisticId: optimisticId,
          // A rota por contato precisa da conexão escolhida no seletor para criar
          // o chamado no número certo; na rota do ticket o backend ignora.
          ...(preferredWhatsappId ? { whatsappId: preferredWhatsappId } : {}),
          ...(queueChoice.queueId ? { queueId: queueChoice.queueId } : {}),
          ...(forceNewTicket ? { forceNewTicket: true } : {}),
          // Instagram: quando o atendente escolheu responder a um comentário
          // específico (botão "Responder"), envia o alvo e o modo. Sem alvo,
          // o envio é um DM normal da conversa (padrão).
          ...(instagramReplyTarget && !isQuickText
            ? {
                instagramCommentId: instagramReplyTarget.commentId,
                instagramReplyMode: instagramReplyTarget.mode,
              }
            : {})
        };

        const endpoint = resolveSendEndpoint(finalTicketId, ownership.viaContact);
        sentRequest = { endpoint, message };
        console.log('[MessageInput] Fazendo POST para ' + endpoint);
        const response = await api.post(endpoint, message);
        console.log('[MessageInput] Mensagem enviada com sucesso:', response.data);

        // Cloud API sem janela aberta: o backend responde 200 pedindo template.
        if (response.data?.requiresTemplate) {
          removeOptimisticMessage(ticketId, optimisticId);
          if (!isQuickText) {
            setInputMessage((prev) => (prev ? prev : currentMessage));
          }
          onMessageSent?.(response.data);
          return;
        }

        // Chat de contato: o chamado só nasce agora, então a bolha otimista
        // precisa migrar da chave pseudo ("contact-<id>") para o ticket real —
        // é por esse id que o socket vai reconciliá-la.
        if (response.data?.ticket?.id) {
          reassignOptimisticMessage(ticketId, response.data.ticket.id, optimisticId);
        }

        // Limpa o alvo de resposta a comentário após enviar.
        if (instagramReplyTarget && setInstagramReplyTarget && !isQuickText) {
          setInstagramReplyTarget(null);
        }

        onMessageSent?.(response.data);
        followViaContactTicket(ownership, response.data);

      } catch (err) {
        console.error('[MessageInput] Erro ao enviar mensagem:', err, err?.response?.data);
        const code = err?.response?.data?.error;

        // Cloud API: janela de 24h expirada - perguntar se deseja enviar template
        if (code === 'ERR_CLOUDAPI_WINDOW_CLOSED') {
          handleOpenTemplatePicker();
          return;
        }

        // Handle transient whatsapp connection errors by queueing the message.
        // Só faz sentido com chamado real: a fila de retry reenvia por ticketId.
        if (hasRealTicket && (code === 'ERR_WAPP_NOT_INITIALIZED' || code === 'ERR_WAPP_NOT_CONNECTED')) {
          try {
            // Validar se ticketUuid ou ticketId existem
            if (!ticketUuid && !ticketId) {
              console.warn('[MessageInput] Nem ticketUuid nem ticketId definidos, abortando');
              toastError({ message: i18n.t("messagesInput.errors.ticketIdNotFound") });
              return;
            }
            
            // Autor: GitHub Copilot | Data: 16/04/2026 | Motivo: quando o ticket final
            // é resolvido para outro ID (ex.: ERR_OTHER_OPEN_TICKET ao assumir chamado),
            // a fila deve persistir usando esse ID para garantir retry no ticket correto.
            const endpoint = ticketUuid && Number(finalTicketId) === Number(ticketId)
              ? `/tickets/u/${ticketUuid}`
              : `/tickets/${finalTicketId}`;
            const { data: ticketData } = await api.get(endpoint);
            const whatsappId = ticketData.whatsappId;

            const tempId = `pending-${Date.now()}`;
            queueMessage({
              tempId,
              ticketId: finalTicketId,
              whatsappId,
              body: wireMessage,
              displayBody: currentMessage,
              userName: user?.name || '',
              mentionedJids,
              quotedMsg: currentQuotedMsg || null,
              createdAt: new Date().toISOString(),
              status: 'pending',
              optimisticId
            });
          } catch (err2) {
            toastError(err2);
          }
        } else {
          // A mensagem não saiu: tira a bolha otimista e devolve o texto (com a
          // citação) para o atendente reenviar.
          removeOptimisticMessage(ticketId, optimisticId);
          if (!isQuickText) {
            setInputMessage((prev) => (prev ? prev : currentMessage));
            setReplyingMessage((prev) => prev || currentQuotedMsg || null);
          }

          // Reenvio do mesmo texto depois que o atendente responde ao aviso de
          // chamado com outro atendente (assumir → mesmo corpo; abrir novo →
          // `forceNewTicket`). Sai do input só se ele ainda é o texto devolvido.
          const failedRequest = sentRequest;
          const retry = failedRequest
            ? async (extra = {}) => {
                const { optimisticId: _unused, ...body } = failedRequest.message;
                const { data } = await api.post(failedRequest.endpoint, { ...body, ...extra });
                if (!isQuickText) {
                  setInputMessage((prev) => (prev === currentMessage ? "" : prev));
                  setReplyingMessage((prev) =>
                    prev && currentQuotedMsg && prev.id === currentQuotedMsg.id ? null : prev
                  );
                }
                onMessageSent?.(data);
                return data;
              }
            : undefined;

          // Quem monta o input trata primeiro o que é dele (modal de conflito de
          // chamado, aviso de conexão fora do escopo); só o resto vira toast aqui.
          if (!onSendError?.(err, { retry })) {
            toastError(err);
          }
        }
      } finally {
        if (sendGuardRef.current.inFlightSignature === currentSignature) {
          sendGuardRef.current.inFlightSignature = "";
        }
        setSendingText(false);
      }
    })();
  };

  handleSendMessageRef.current = handleSendMessage;

  // Botão/linha de lista clicado na conversa (MessagesList): chega como evento,
  // no molde do "onspace:conversation-file-drop". Pode haver mais de um
  // MessageInput montado, então só consome quem é do mesmo chamado (ou do mesmo
  // contato, quando ainda não há chamado), e o preventDefault() avisa os demais
  // de que o evento já tem dono.
  useEffect(() => {
    const handleQuickText = (event) => {
      if (event.defaultPrevented) return;

      const detail = event?.detail || {};
      if (typeof detail.text !== "string" || detail.text.trim() === "") return;

      const matchesTarget =
        detail.ticketId && ticketId
          ? String(detail.ticketId) === String(ticketId)
          : Boolean(
              detail.contactId &&
                contactId &&
                String(detail.contactId) === String(contactId)
            );
      if (!matchesTarget) return;

      event.preventDefault();
      handleSendMessageRef.current?.(detail.text);
    };

    window.addEventListener("onspace:send-quick-text", handleQuickText);

    return () => {
      window.removeEventListener("onspace:send-quick-text", handleQuickText);
    };
  }, [ticketId, contactId]);

  const handleStartRecording = async () => {
    setLoading(true);
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      await Mp3Recorder.start();
      enableRecorderPause(Mp3Recorder);
      setRecordingPaused(false);
      setRecording(true);
      setLoading(false);
    } catch (err) {
      toastError(err);
      setLoading(false);
    }
  };

  // Áudio gravado que não saiu (erro no envio, aviso de chamado com outro
  // atendente, popup de fila cancelado): fica guardado com "Reenviar" e
  // "Descartar" em vez de sumir. Antes o atendente perdia a gravação inteira.
  const keepFailedAudio = (blob, filename, quotedMsg) => {
    setFailedAudio((prev) =>
      prev?.blob === blob
        ? prev
        : { blob, filename, quotedMsg, url: URL.createObjectURL(blob) }
    );
  };

  const clearFailedAudio = () => setFailedAudio(null);

  // Mesmo pipeline do texto e da mídia. Erro → guarda o áudio; o aviso de
  // chamado com outro atendente (onSendError) recebe o `retry` deste áudio.
  const sendAudioBlob = async (blob, filename, currentQuotedMsg) => {
    const queueChoice = await resolveQueueForNewTicket();
    if (!queueChoice.proceed) {
      keepFailedAudio(blob, filename, currentQuotedMsg);
      return;
    }

    const buildFormData = (extra = {}) => {
      const formData = new FormData();
      formData.append("body", filename);
      formData.append("fromMe", true);
      // Chat de contato: o chamado nasce na conexão escolhida no seletor (o
      // texto e a mídia já mandavam; o áudio caía na conexão automática).
      if (preferredWhatsappId) {
        formData.append("whatsappId", String(preferredWhatsappId));
      }
      if (queueChoice.queueId) {
        formData.append("queueId", String(queueChoice.queueId));
      }
      if (forceNewTicket || extra.forceNewTicket) {
        formData.append("forceNewTicket", "true");
      }
      if (currentQuotedMsg?.id) {
        formData.append("quotedMsgId", String(currentQuotedMsg.id));
      }
      formData.append("medias", blob, filename);
      return formData;
    };

    let ownership = null;
    try {
      // Mesma regra do texto e da mídia: quem envia assume o chamado.
      ownership = await ensureTicketOwnershipForSend();
      if (!ownership.proceed) {
        keepFailedAudio(blob, filename, currentQuotedMsg);
        return;
      }
      if (ownership.warning) {
        toast.warn(ownership.warning);
      }

      const { data } = await api.post(
        resolveSendEndpoint(ownership.ticketId, ownership.viaContact),
        buildFormData(),
        { timeout: MEDIA_UPLOAD_TIMEOUT_MS }
      );
      // Só limpa no sucesso: em caso de erro o atendente reenvia mantendo a citação.
      setReplyingMessage(null);
      clearFailedAudio();
      onMessageSent?.(data);
      followViaContactTicket(ownership, data);
    } catch (err) {
      keepFailedAudio(blob, filename, currentQuotedMsg);

      const retry = async (extra = {}) => {
        const { data } = await api.post(
          resolveSendEndpoint(ownership?.ticketId ?? ticketId, ownership?.viaContact),
          buildFormData(extra),
          { timeout: MEDIA_UPLOAD_TIMEOUT_MS }
        );
        clearFailedAudio();
        setReplyingMessage((prev) =>
          prev && currentQuotedMsg && prev.id === currentQuotedMsg.id ? null : prev
        );
        onMessageSent?.(data);
        return data;
      };

      if (!onSendError?.(err, { retry })) {
        toastError(err);
      }
    }
  };

  const handlePauseAudio = () => {
    pauseRecorder(Mp3Recorder);
    setRecordingPaused(true);
  };

  const handleResumeAudio = () => {
    resumeRecorder(Mp3Recorder);
    setRecordingPaused(false);
  };

  const handleUploadAudio = async () => {
    setLoading(true);
    // Congela a citação antes de qualquer await (igual ao handleSendMessage).
    const currentQuotedMsg = replyingMessage;
    try {
      // Pausado ou não, o stop fecha o MP3 com todos os trechos gravados.
      const [, blob] = await Mp3Recorder.stop().getMp3();
      setRecording(false);
      setRecordingPaused(false);
      if (blob.size < 10000) {
        return;
      }

      const filename = `audio-record-site-${new Date().getTime()}.mp3`;
      await sendAudioBlob(blob, filename, currentQuotedMsg);
    } catch (err) {
      toastError(err);
    } finally {
      setRecording(false);
      setLoading(false);
    }
  };

  const handleResendFailedAudio = async () => {
    if (!failedAudio || loading) return;
    setLoading(true);
    try {
      await sendAudioBlob(failedAudio.blob, failedAudio.filename, failedAudio.quotedMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelAudio = async () => {
    try {
      await Mp3Recorder.stop().getMp3();
      setRecording(false);
      setRecordingPaused(false);
    } catch (err) {
      toastError(err);
    }
  };

  // ESC no rodapé de digitação: fecha primeiro o que estiver aberto AQUI
  // (emoji, gravação, anexo, edição, citação), igual ao WhatsApp Web. Roda em
  // captura e marca o evento com preventDefault() para o listener do Ticket
  // saber que a tecla já foi consumida e não fechar a conversa junto.
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key !== "Escape" || e.defaultPrevented) return;
      // Dialog/popover/visualizador aberto tem prioridade: ele fecha sozinho.
      if (hasOpenOverlay()) return;

      if (showEmoji) {
        setShowEmoji(false);
      } else if (recording) {
        handleCancelAudio();
      } else if (medias.length > 0) {
        setMedias([]);
        setMediaCaption("");
      } else if (editingMessage) {
        setEditingMessage(null);
        setInputMessage("");
      } else if (replyingMessage || instagramReplyTarget) {
        setReplyingMessage(null);
        setInstagramReplyTarget(null);
      } else {
        return; // nada aqui para fechar: deixa o Ticket fechar a conversa
      }

      e.preventDefault();
    };

    window.addEventListener("keydown", handleEscape, true);
    return () => window.removeEventListener("keydown", handleEscape, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    showEmoji,
    recording,
    medias.length,
    editingMessage,
    replyingMessage,
    instagramReplyTarget,
  ]);

  const selectedWhatsapp = Array.isArray(props.whatsapps)
    ? props.whatsapps.find((w) => Number(w.id) === Number(props.selectedWhatsappId))
    : null;

  const activeWhatsapp = props.whatsapp || selectedWhatsapp || null;
  const isCloudApiWindowClosed = activeWhatsapp?.type === "cloudapi" && props.cloudApiWindowOpen === false;
  const isTemplateOnlyMode = isCloudApiWindowClosed;

  const disableOption = () => {
    return loading || sendingText || recording || isCloudApiWindowClosed;
  };

  const quickActionsMenuOpen = Boolean(quickActionsAnchorEl);

  const handleOpenQuickActionsMenu = (event) => {
    setQuickActionsAnchorEl(event.currentTarget);
  };

  const handleCloseQuickActionsMenu = () => {
    setQuickActionsAnchorEl(null);
  };

  const handleOpenAttachMenuAction = () => {
    handleCloseQuickActionsMenu();
    if (quickActionsUploadInputRef.current) {
      quickActionsUploadInputRef.current.value = "";
      quickActionsUploadInputRef.current.click();
    }
  };

  const renderPromotedActions = () => {
    return (
      <>
        {!isTemplateOnlyMode && (
          <Tooltip title={i18n.t("messagesInput.tooltips.sendContact")}>
            <IconButton
              aria-label="sendContact"
              component="span"
              disabled={disableOption()}
              onClick={() => setContactModalOpen(true)}
            >
              <PersonIcon className={classes.sendMessageIcons} />
            </IconButton>
          </Tooltip>
        )}

        {!isTemplateOnlyMode && (
          <Tooltip title={i18n.t("messagesInput.tooltips.quickMessages")}>
            <IconButton
              aria-label="quickMessages"
              component="span"
              disabled={disableOption()}
              onClick={handleOpenQuickMessageModal}
            >
              <FlashOnIcon className={classes.sendMessageIcons} />
            </IconButton>
          </Tooltip>
        )}

        {!isTemplateOnlyMode && hasRealTicket && (
          <Tooltip title={i18n.t("documentTemplates.sendModal.title")}>
            <IconButton
              aria-label="sendDocumentTemplate"
              component="span"
              disabled={disableOption()}
              onClick={() => handleOpenDocumentModal(null)}
            >
              <DescriptionIcon className={classes.sendMessageIcons} />
            </IconButton>
          </Tooltip>
        )}

        {/* Catálogo só existe em conexões de telefone (Baileys/Cloud API). */}
        {!isTemplateOnlyMode &&
          hasRealTicket &&
          ["baileys", "cloudapi"].includes(activeWhatsapp?.type || "baileys") && (
            <Tooltip title={i18n.t("catalog.picker.title")}>
              <IconButton
                aria-label="sendCatalogProduct"
                component="span"
                disabled={disableOption()}
                onClick={() => setCatalogPickerOpen(true)}
              >
                <StorefrontIcon className={classes.sendMessageIcons} />
              </IconButton>
            </Tooltip>
          )}

        {activeWhatsapp?.type === "cloudapi" && (
          <Tooltip title={i18n.t("messagesInput.tooltips.sendTemplate")}>
            <IconButton
              aria-label="sendTemplate"
              component="span"
              disabled={loading || recording}
              onClick={handleOpenTemplatePicker}
            >
              <MessageIcon
                className={classes.sendMessageIcons}
                style={isCloudApiWindowClosed ? { color: "#ff9800" } : undefined}
              />
            </IconButton>
          </Tooltip>
        )}
      </>
    );
  };

  const handleOpenStickersMenuAction = () => {
    handleCloseQuickActionsMenu();
    handleOpenStickerPicker();
  };

  const handleOpenEmojiMenuAction = () => {
    handleCloseQuickActionsMenu();
    setShowEmoji((prevState) => !prevState);
  };

  const handleToggleSignMessage = (_event, checked) => {
    setSignMessage(checked);
  };

  const handleOpenAIAgentMenuAction = () => {
    handleCloseQuickActionsMenu();
    setAiAgentModalOpen(true);
  };

  const handleCloseAIAgentModal = () => {
    setAiAgentModalOpen(false);
  };

  const renderQuickActionsMenu = () => {
    return (
      <>
        <input
          multiple
          type="file"
          ref={quickActionsUploadInputRef}
          disabled={disableOption()}
          className={classes.uploadInput}
          onChange={handleChangeMedias}
        />

        <Tooltip title={i18n.t("messagesInput.tooltips.moreActions")}>
          <IconButton
            aria-label="moreActions"
            component="span"
            disabled={disableOption() && !isTemplateOnlyMode}
            onClick={handleOpenQuickActionsMenu}
          >
            <MoreVertIcon className={classes.sendMessageIcons} />
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={quickActionsAnchorEl}
          open={quickActionsMenuOpen}
          onClose={handleCloseQuickActionsMenu}
          keepMounted
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          {!isTemplateOnlyMode && (
            <MenuItem onClick={handleOpenAttachMenuAction} disabled={disableOption()}>
              <ListItemIcon>
                <AttachFileIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={i18n.t("messagesInput.tooltips.attachFile")} />
            </MenuItem>
          )}

          {!isTemplateOnlyMode && (
            <MenuItem onClick={handleOpenStickersMenuAction} disabled={disableOption()}>
              <ListItemIcon>
                <CollectionsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={i18n.t("messagesInput.tooltips.stickers")} />
            </MenuItem>
          )}

          {!isTemplateOnlyMode && (
            <MenuItem onClick={handleOpenEmojiMenuAction} disabled={disableOption()}>
              <ListItemIcon>
                <MoodIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary={i18n.t("messagesInput.tooltips.emojiPicker")} />
            </MenuItem>
          )}

          <MenuItem onClick={handleOpenAIAgentMenuAction} disabled={loading || sendingText || recording}>
            <ListItemIcon>
              <RobotIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={i18n.t("ticketOptionsMenu.agents")} />
          </MenuItem>
        </Menu>

        <ContactSearchModal
          open={contactModalOpen}
          onClose={() => setContactModalOpen(false)}
          onSelectContact={handleSelectContact}
        />

        <QuickMessageModal
          open={quickMessageModalOpen}
          onClose={handleCloseQuickMessageModal}
          onSelectMessage={handleQuickAnswersClick}
        />

        {hasRealTicket && (
          <CatalogProductPickerModal
            open={catalogPickerOpen}
            onClose={() => setCatalogPickerOpen(false)}
            ticketId={ticketId}
            whatsappId={activeWhatsapp?.id}
          />
        )}

        <ForbiddenWordWarningModal
          open={forbiddenWarning.open}
          matches={forbiddenWarning.matches}
          onClose={handleCloseForbiddenWarning}
          onReplace={handleReplaceForbidden}
          onSendAnyway={() => {
            const quickText = pendingQuickTextRef.current;
            pendingQuickTextRef.current = null;
            setForbiddenWarning({ open: false, matches: [] });
            bypassForbiddenCheckRef.current = true;
            handleSendMessage(quickText === null ? undefined : quickText);
          }}
        />

        {hasRealTicket && (
          <DocumentSendModal
            open={documentModalOpen}
            onClose={handleCloseDocumentModal}
            ticketId={ticketId}
            preselectedTemplateId={documentTemplateId}
          />
        )}

        <TicketAIAgentModal
          open={aiAgentModalOpen}
          onClose={handleCloseAIAgentModal}
          ticketId={ticketId}
        />

        {showEmoji ? (
          <div className={classes.emojiBox}>
            <Picker
              perLine={16}
              showPreview={false}
              showSkinTones={false}
              onSelect={handleAddEmoji}
            />
          </div>
        ) : null}
      </>
    );
  };

  // Função para extrair o nome do remetente em grupos
  const getSenderName = (message) => {
    if (!isGroup || message.fromMe) {
      return message.contact?.name;
    }

    // Tenta extrair o pushName do dataJson (dados originais do WhatsApp)
    if (message.dataJson) {
      try {
        const data = JSON.parse(message.dataJson);
        if (data.pushName) return data.pushName;
        if (data.verifiedBizName) return data.verifiedBizName;
        if (data.notify) return data.notify;
      } catch (e) {
        // Se falhar o parse, usa o nome do contato
      }
    }

    if (message.participant) {
      const number = message.participant.split('@')[0].split(':')[0];
      return number;
    }

    return message.contact?.name;
  };

  const renderReplyingMessage = (message) => {
    // Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: evitar exibicao de VCARD bruto na citacao de resposta.
    const extractNameFromVcard = (vcard) => {
      const rawVcard = String(vcard || "");
      const match = rawVcard.match(/FN[^:]*:(.+)/i);
      return match?.[1]?.trim() || "";
    };

    const extractNumberFromVcard = (vcard) => {
      const rawVcard = String(vcard || "");
      const waidMatch = rawVcard.match(/waid=(\d+)/i);
      if (waidMatch?.[1]) {
        return waidMatch[1];
      }

      const telMatch = rawVcard.match(/TEL[^:]*:([^\n\r]+)/i);
      if (telMatch?.[1]) {
        return telMatch[1].replace(/[^\d+]/g, "");
      }

      return "";
    };

    const getReplyPreviewText = (replyMessage) => {
      const mediaType = String(replyMessage?.mediaType || "").toLowerCase();
      const body = String(replyMessage?.body || "");
      const isContactVcard = mediaType === "vcard" || mediaType === "contactmessage" || body.includes("BEGIN:VCARD");

      if (!isContactVcard) {
        return replyMessage?.body;
      }

      const contactName = extractNameFromVcard(body);
      const contactNumber = extractNumberFromVcard(body);

      if (contactName && contactNumber) {
        return i18n.t("messagesInput.replyPreview.contactWithNumber", { name: contactName, number: contactNumber });
      }

      if (contactName) {
        return i18n.t("messagesInput.replyPreview.contact", { value: contactName });
      }

      if (contactNumber) {
        return i18n.t("messagesInput.replyPreview.contact", { value: contactNumber });
      }

      return i18n.t("messagesInput.replyPreview.sharedContact");
    };

    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span
            className={clsx(classes.replyginContactMsgSideColor, {
              [classes.replyginSelfMsgSideColor]: !message.fromMe,
            })}
          ></span>
          <div className={classes.replyginMsgBody}>
            {!message.fromMe && (
              <span className={classes.messageContactName}>
                {getSenderName(message)}
              </span>
            )}
            {getReplyPreviewText(message)}
          </div>
        </div>
        <IconButton
          aria-label="showRecorder"
          component="span"
          // Fechar a citação é estado local: não pode depender do status do
          // ticket (em pending o envio funciona e o X ficava travado).
          disabled={loading}
          onClick={() => setReplyingMessage(null)}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  const renderEditingMessage = (message) => {
    return (
      <div className={classes.replyginMsgWrapper}>
        <div className={classes.replyginMsgContainer}>
          <span className={classes.replyginSelfMsgSideColor}></span>
          <div className={classes.replyginMsgBody}>
            <span className={classes.messageContactName}>
              {i18n.t("messageOptionsMenu.editModal.title")}
            </span>
            {message.body}
          </div>
        </div>
        <IconButton
          aria-label="cancelEdit"
          component="span"
          disabled={loading || ticketStatus !== "open"}
          onClick={() => {
            setEditingMessage(null);
            setInputMessage("");
          }}
        >
          <ClearIcon className={classes.sendMessageIcons} />
        </IconButton>
      </div>
    );
  };

  // Áudio que não saiu: dá para ouvir, reenviar ou descartar (ver keepFailedAudio).
  const renderFailedAudio = () => (
    <div className={classes.replyginMsgWrapper}>
      <div className={classes.replyginMsgContainer}>
        <span className={classes.replyginSelfMsgSideColor}></span>
        <div className={classes.replyginMsgBody}>
          <span className={classes.messageContactName}>
            {i18n.t("messagesInput.failedAudio.title")}
          </span>
          <audio controls src={failedAudio.url} style={{ display: "block", width: "100%", height: 32 }} />
        </div>
      </div>
      <Tooltip title={i18n.t("messagesInput.failedAudio.resend")}>
        <span>
          <IconButton
            aria-label="resendFailedAudio"
            component="span"
            disabled={loading || recording}
            onClick={handleResendFailedAudio}
          >
            <SendIcon className={classes.sendMessageIcons} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title={i18n.t("messagesInput.failedAudio.discard")}>
        <span>
          <IconButton
            aria-label="discardFailedAudio"
            component="span"
            disabled={loading}
            onClick={clearFailedAudio}
          >
            <ClearIcon className={classes.sendMessageIcons} />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );

  // Função helper para renderizar os dialogs de Cloud API (compartilhado entre ambos os branches de return)
  const renderQueueDialog = () => (
    <QueueSelectDialog
      open={queueDialogOpen}
      queues={user?.queues || []}
      onSelect={handleQueueDialogSelect}
      onClose={handleQueueDialogClose}
    />
  );

  const renderCloudApiDialogs = () => (
    <>
      {/* Dialog único - janela expirada + seleção de template */}
      <Dialog
        open={templatePickerOpen}
        onClose={() => setTemplatePickerOpen(false)}
        maxWidth="sm"
        fullWidth
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
      >
        <DialogTitle>{i18n.t("messagesInput.cloudApi.windowExpiredTitle")}</DialogTitle>
        <DialogContent>
          <DialogContentText style={{ marginBottom: 16 }}>
            {i18n.t("messagesInput.cloudApi.windowExpiredText")}
          </DialogContentText>
          {loadingTemplates ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : cloudApiTemplates.length === 0 ? (
            <DialogContentText>
              {i18n.t("messagesInput.cloudApi.noTemplates")}
            </DialogContentText>
          ) : (
            <>
              <FormControl fullWidth variant="outlined" margin="dense">
                <InputLabel>{i18n.t("messagesInput.cloudApi.selectTemplate")}</InputLabel>
                <Select
                  value={selectedCloudApiTemplate}
                  onChange={(e) => handleSelectCloudApiTemplate(e.target.value)}
                  label={i18n.t("messagesInput.cloudApi.selectTemplate")}
                >
                  {cloudApiTemplates.map((t) => (
                    <MenuItem key={t.id} value={t.id}>
                      {t.displayName || t.name} ({t.language}) - {t.category}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {(() => {
                const selObj = cloudApiTemplates.find((t) => t.id === parseInt(selectedCloudApiTemplate));
                if (!selObj) return null;
                return (
                  <Box mt={2} p={2} bgcolor="background.default" border={1} borderColor="divider" borderRadius={4}>
                    <Typography variant="caption" color="textSecondary">
                      {i18n.t("messagesInput.cloudApi.preview")}
                    </Typography>
                    <Typography variant="body2" style={{ whiteSpace: "pre-wrap" }}>
                      {selObj.bodyText || i18n.t("messagesInput.cloudApi.emptyBody")}
                    </Typography>
                  </Box>
                );
              })()}

              {cloudApiTemplateVars.length > 0 && (
                <Box mt={2} key="template-vars">
                  <Typography variant="caption" color="textSecondary">
                    {i18n.t("messagesInput.cloudApi.variables")}
                  </Typography>
                  {cloudApiTemplateVars.map((varItem, index) => (
                    <TextField
                      key={`var-${varItem.name}-${index}`}
                      label={i18n.t("messagesInput.cloudApi.variableLabel", { name: `{{${varItem.name}}}` })}
                      value={varItem.value}
                      onChange={(e) => {
                        const newVars = [...cloudApiTemplateVars];
                        newVars[index].value = e.target.value;
                        setCloudApiTemplateVars(newVars);
                      }}
                      fullWidth
                      variant="outlined"
                      size="small"
                      style={{ marginTop: 8 }}
                    />
                  ))}
                </Box>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setTemplatePickerOpen(false)}>{i18n.t("common.cancel")}</Button>
          <Button
            onClick={handleSendCloudApiTemplate}
            color="primary"
            variant="contained"
            disabled={!selectedCloudApiTemplate || sendingTemplate || loadingTemplates}
          >
            {sendingTemplate ? i18n.t("messagesInput.cloudApi.sending") : i18n.t("messagesInput.cloudApi.send")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );

  const renderStickerDialog = () => (
    <>
    <Dialog
      open={stickerPickerOpen}
      onClose={() => setStickerPickerOpen(false)}
      maxWidth="sm"
      fullWidth
      disableAutoFocus
      disableEnforceFocus
      disableRestoreFocus
    >
      <DialogTitle>{i18n.t("messagesInput.tooltips.stickers")}</DialogTitle>
      <DialogContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Button onClick={loadStickerLibrary} disabled={loadingStickers || loading}>
            {i18n.t("common.refresh")}
          </Button>
          <Button
            color="primary"
            variant="outlined"
            onClick={handlePullStickersFromWhatsApp}
            disabled={loadingStickers || loading}
          >
            {i18n.t("messagesInput.stickers.pullFromWhatsApp")}
          </Button>
        </Box>

        {loadingStickers ? (
          <Box display="flex" justifyContent="center" p={3}>
            <CircularProgress />
          </Box>
        ) : stickerLibrary.length === 0 && favoriteStickers.length === 0 ? (
          <DialogContentText style={{ marginTop: 12 }}>
            {i18n.t("messagesInput.stickers.empty")}
          </DialogContentText>
        ) : (
          <>
            {favoriteStickers.length > 0 && (
              <>
                <Typography variant="caption" color="textSecondary" style={{ marginTop: 12, display: "block" }}>
                  {i18n.t("messagesInput.stickers.favorites")}
                </Typography>
                <div className={classes.stickersGrid}>
                  {favoriteStickers.map((mediaUrl) => (
                    <div key={`fav-${mediaUrl}`} className={classes.stickerTileWrapper}>
                      <IconButton
                        className={classes.stickerFavoriteButton}
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          handleToggleStickerFavorite(mediaUrl);
                        }}
                      >
                        <StarIcon fontSize="small" color="primary" />
                      </IconButton>
                      <Tooltip title={i18n.t("messagesInput.stickers.removeFromLibrary")}>
                        <span className={classes.stickerDeleteButton}>
                          <IconButton
                            size="small"
                            disabled={deletingSticker || loading}
                            onClick={(event) => {
                              event.stopPropagation();
                              handleAskRemoveStickerFromLibrary(mediaUrl);
                            }}
                          >
                            <DeleteOutlineIcon fontSize="small" color="error" />
                          </IconButton>
                        </span>
                      </Tooltip>
                      <IconButton
                        className={classes.stickerItemButton}
                        onClick={() => handleSendStickerFromLibrary({ id: mediaUrl, mediaUrl })}
                        disabled={loading}
                      >
                        <img src={mediaUrl} alt="sticker" className={classes.stickerThumb} />
                      </IconButton>
                    </div>
                  ))}
                </div>
              </>
            )}

            <Typography variant="caption" color="textSecondary" style={{ marginTop: 12, display: "block" }}>
              {i18n.t("messagesInput.stickers.library")}
            </Typography>
            <div className={classes.stickersGrid}>
              {stickerLibrary.map((sticker) => (
                <div key={sticker.id} className={classes.stickerTileWrapper}>
                  <IconButton
                    className={classes.stickerFavoriteButton}
                    size="small"
                    onClick={(event) => {
                      event.stopPropagation();
                      handleToggleStickerFavorite(sticker.mediaUrl);
                    }}
                  >
                    {isFavoriteSticker(sticker.mediaUrl) ? (
                      <StarIcon fontSize="small" color="primary" />
                    ) : (
                      <StarBorderIcon fontSize="small" />
                    )}
                  </IconButton>
                  <Tooltip title={i18n.t("messagesInput.stickers.removeFromLibrary")}>
                    <span className={classes.stickerDeleteButton}>
                      <IconButton
                        size="small"
                        disabled={deletingSticker || loading}
                        onClick={(event) => {
                          event.stopPropagation();
                          handleAskRemoveStickerFromLibrary(sticker.mediaUrl);
                        }}
                      >
                        <DeleteOutlineIcon fontSize="small" color="error" />
                      </IconButton>
                    </span>
                  </Tooltip>
                  <IconButton
                    className={classes.stickerItemButton}
                    onClick={() => handleSendStickerFromLibrary(sticker)}
                    disabled={loading}
                  >
                    <img src={sticker.mediaUrl} alt="sticker" className={classes.stickerThumb} />
                  </IconButton>
                </div>
              ))}
            </div>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setStickerPickerOpen(false)}>{i18n.t("common.close")}</Button>
      </DialogActions>
    </Dialog>

    <ConfirmationModal
      title={i18n.t("messagesInput.stickers.removeTitle")}
      open={confirmDeleteStickerOpen}
      onClose={setConfirmDeleteStickerOpen}
      onConfirm={handleRemoveStickerFromLibrary}
    >
      {i18n.t("messagesInput.stickers.removeConfirm")}
    </ConfirmationModal>
    </>
  );

  if (medias.length > 0)
    return (
      <>
      {/* Sem este banner o atendente perde de vista que está respondendo alguém
          no exato momento em que anexa o arquivo. */}
      {replyingMessage && (
        <Paper square elevation={0} className={classes.mainWrapper}>
          {renderReplyingMessage(replyingMessage)}
        </Paper>
      )}
      <Paper elevation={0} square className={classes.viewMediaInputWrapper}>
   
        {dragActive && (
        <div className={classes.dropZoneOverlay}>
            {i18n.t("messagesInput.media.dropHere")}
        </div>
        )}

        <IconButton
          aria-label="cancel-upload"
          component="span"
          onClick={(e) => {
            setMedias([]);
            setMediaCaption("");
          }}
        >
          <CancelIcon className={classes.sendMessageIcons} />
        </IconButton>

        <FileInput
          disableOption={disableOption}
          handleChangeMedias={handleChangeMedias}
        />

        {loading ? (
          <div>
            <CircularProgress className={classes.circleLoading} />
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", flex: 1, marginLeft: 10, marginRight: 10 }}>
            <span className={classes.mediaInputFileName}>
              {i18n.t("messagesInput.media.filesSelected", { count: medias.length })}
            </span>

            <div className={classes.mediaPreviewList}>
              {medias.map((media, index) => {
                const mediaKind = getMediaKind(media);
                const preview = mediaPreviews[index];
                const previewKey = preview?.key || `${media.name}-${media.size}-${media.lastModified}-${index}`;
                const hasPreviewError = Boolean(previewErrors[previewKey]);

                return (
                  <div key={previewKey} className={classes.mediaPreviewCard}>
                    <IconButton
                      size="small"
                      className={classes.removeMediaButton}
                      onClick={() => handleRemoveMedia(index)}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>

                    {mediaKind === "image" && preview?.url && !hasPreviewError ? (
                      <img
                        src={preview.url}
                        alt={media.name}
                        className={classes.mediaPreviewThumb}
                        onError={() => {
                          setPreviewErrors((prev) => ({ ...prev, [previewKey]: true }));
                        }}
                      />
                    ) : mediaKind === "video" && preview?.url && !hasPreviewError ? (
                      <video
                        src={preview.url}
                        className={classes.mediaPreviewThumb}
                        muted
                        preload="metadata"
                        onError={() => {
                          setPreviewErrors((prev) => ({ ...prev, [previewKey]: true }));
                        }}
                      />
                    ) : (
                      <div className={classes.mediaPreviewFallback}>
                        {renderFileTypeIcon(media)}
                      </div>
                    )}

                    <span className={classes.mediaPreviewName} title={media.name}>
                      {media.name}
                    </span>
                  </div>
                );
              })}

              <>
                <input
                  multiple
                  type="file"
                  id="upload-button-more"
                  className={classes.uploadInput}
                  onChange={handleChangeMedias}
                />
                <label htmlFor="upload-button-more" className={classes.addMoreMediaCard}>
                  <AddCircleOutlineIcon className={classes.addMoreMediaIcon} color="action" />
                </label>
              </>
            </div>

            <InputBase
              placeholder={i18n.t("messagesInput.media.captionPlaceholder")}
              value={mediaCaption}
              onChange={(e) => setMediaCaption(e.target.value)}
              onPaste={handleInputPaste}
              onKeyPress={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  handleUploadMedia(e);
                }
              }}
              disabled={loading}
              className={classes.mediaInputCaption}
              fullWidth
              autoFocus
            />
          </div>
        )}
        <IconButton
          aria-label="send-upload"
          component="span"
          onClick={handleUploadMedia}
          disabled={loading}
        >
          <SendIcon className={classes.sendMessageIcons} />
        </IconButton>
      </Paper>
      {renderCloudApiDialogs()}
      {renderStickerDialog()}
      {renderQueueDialog()}
      </>
    );
  else {
    return (
      <>
      <Paper square elevation={0} className={classes.mainWrapper}>
        {instagramReplyTarget && (
          <div style={{ display: "flex", gap: 8, alignItems: "center", padding: "6px 10px", fontSize: 13, borderLeft: `3px solid ${instagramReplyTarget.mode === "public" ? "#E1306C" : "#833AB4"}`, background: "rgba(131,58,180,0.06)" }}>
            <span style={{ fontWeight: 600, color: instagramReplyTarget.mode === "public" ? "#E1306C" : "#833AB4" }}>
              {instagramReplyTarget.mode === "public" ? i18n.t("messagesInput.instagram.replyingPublic") : i18n.t("messagesInput.instagram.replyingDm")}
            </span>
            {instagramReplyTarget.preview && (
              <span style={{ color: "#888", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 280 }}>
                — “{instagramReplyTarget.preview}”
              </span>
            )}
            <IconButton size="small" style={{ marginLeft: "auto" }} onClick={() => setInstagramReplyTarget(null)}>
              <ClearIcon style={{ fontSize: 18 }} />
            </IconButton>
          </div>
        )}
        {replyingMessage && renderReplyingMessage(replyingMessage)}
        {editingMessage && renderEditingMessage(editingMessage)}
        {failedAudio && renderFailedAudio()}
        {ticketStatus === "pending" ? (
          <div className={classes.pendingAcceptWrapper}>
            {/* Botão de aceitar removido - ticket será aceito automaticamente ao enviar mensagem */}
            <div
                className={classes.newMessageBox}
                onDrop={handleDrop}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
            >
              {renderQuickActionsMenu()}
              {renderPromotedActions()}

              {!isTemplateOnlyMode && (
                <Tooltip title={i18n.t("messagesInput.tooltips.signMessage")}>
                  <Switch
                    size="small"
                    color="primary"
                    checked={signMessage}
                    disabled={loading || sendingText || recording}
                    onChange={handleToggleSignMessage}
                    inputProps={{ "aria-label": "toggleSignMessage" }}
                  />
                </Tooltip>
              )}

              <CustomInput
                loading={loading}
                sendingText={sendingText}
                inputRef={inputRef}
                ticketStatus={ticketStatus}
                inputMessage={inputMessage}
                setInputMessage={setInputMessage}
                // handleChangeInput={handleChangeInput}
                handleSendMessage={handleSendMessage}
                handleInputPaste={handleInputPaste}
                disableOption={disableOption}
                handleQuickAnswersClick={handleQuickAnswersClick}
                disableAutoFocus={templatePickerOpen}
                whatsapps={props.whatsapps}
                selectedWhatsappId={props.selectedWhatsappId}
                onWhatsappChange={props.onWhatsappChange}
                cloudApiWindowClosed={isCloudApiWindowClosed}
                templateOnlyMode={isTemplateOnlyMode}
                groupParticipants={groupParticipants}
                onMentionSelected={handleMentionSelected}
              />

              {!isTemplateOnlyMode && (
                <ActionButtons
                  inputMessage={inputMessage}
                  loading={loading}
                  sendingText={sendingText}
                  recording={recording}
                  recordingPaused={recordingPaused}
                  ticketStatus={ticketStatus}
                  handleSendMessage={handleSendMessage}
                  handleCancelAudio={handleCancelAudio}
                  handleUploadAudio={handleUploadAudio}
                  handleStartRecording={handleStartRecording}
                  handlePauseAudio={handlePauseAudio}
                  handleResumeAudio={handleResumeAudio}
                />
              )}
            </div>
          </div>
        ) : (
          <div
              className={classes.newMessageBox}
              onDrop={handleDrop}
              onDragEnter={handleDragEnter}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
          >
            {renderQuickActionsMenu()}
            {renderPromotedActions()}

            {!isTemplateOnlyMode && (
              <Tooltip title={i18n.t("messagesInput.tooltips.signMessage")}>
                <Switch
                  size="small"
                  color="primary"
                  checked={signMessage}
                  disabled={loading || sendingText || recording}
                  onChange={handleToggleSignMessage}
                  inputProps={{ "aria-label": "toggleSignMessage" }}
                />
              </Tooltip>
            )}

            <CustomInput
              loading={loading}
              sendingText={sendingText}
              inputRef={inputRef}
              ticketStatus={ticketStatus}
              inputMessage={inputMessage}
              setInputMessage={setInputMessage}
              // handleChangeInput={handleChangeInput}
              handleSendMessage={handleSendMessage}
              handleInputPaste={handleInputPaste}
              disableOption={disableOption}
              handleQuickAnswersClick={handleQuickAnswersClick}
              disableAutoFocus={templatePickerOpen}
              whatsapps={props.whatsapps}
              selectedWhatsappId={props.selectedWhatsappId}
              onWhatsappChange={props.onWhatsappChange}
              cloudApiWindowClosed={isCloudApiWindowClosed}
              templateOnlyMode={isTemplateOnlyMode}
              groupParticipants={groupParticipants}
              onMentionSelected={handleMentionSelected}
            />

            {!isTemplateOnlyMode && (
              <ActionButtons
                inputMessage={inputMessage}
                loading={loading}
                sendingText={sendingText}
                recording={recording}
                recordingPaused={recordingPaused}
                ticketStatus={ticketStatus}
                handleSendMessage={handleSendMessage}
                handleCancelAudio={handleCancelAudio}
                handleUploadAudio={handleUploadAudio}
                handleStartRecording={handleStartRecording}
                handlePauseAudio={handlePauseAudio}
                handleResumeAudio={handleResumeAudio}
              />
            )}
          </div>
        )}
      </Paper>

      {renderCloudApiDialogs()}
      {renderStickerDialog()}
      {renderQueueDialog()}
      </>
    );
  }
};

export default withWidth()(MessageInputCustom);
